import _defineProperty from "/home/marko/Desktop/projektit/avainia-vrj-customerportal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "/home/marko/Desktop/projektit/avainia-vrj-customerportal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/marko/Desktop/projektit/avainia-vrj-customerportal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/marko/Desktop/projektit/avainia-vrj-customerportal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/marko/Desktop/projektit/avainia-vrj-customerportal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import { objectToFormData } from 'object-to-formdata';
import NewRequestService from './NewRequestService.js';

function _catcherInTheCode(e, allow401And403) {
  if (e.status > 199 && e.status < 300) {
    return console.log('Well, this is unexpected. Is this an error? I am ignoring it.', e);
  }

  ;

  if (e.status === 400) {
    return {
      error: 6,
      errorCode: e.errorCode
    };
  }

  if (e.status === 401) {
    if (!allow401And403) {
      if (window) {
        window.triggerLoginCheck = true;
      }
    }

    return {
      error: 4,
      unauthorized: allow401And403,
      errorCode: e.errorCode
    };
  }

  ;

  if (e.message === "User has been disabled.") {
    return {
      error: 44,
      unauthorized: allow401And403,
      errorCode: e.errorCode
    };
  }

  if (e.status === 403) {
    return {
      error: 5,
      unauthorized: allow401And403,
      errorCode: e.errorCode
    };
  }

  if (e.status === 404) {
    return {
      error: 3,
      errorCode: e.errorCode
    };
  }

  if (e.status === 405) {
    return {
      error: 10,
      errorCode: e.errorCode
    };
  }

  if (e.status === 409) {
    return {
      error: 14,
      errorCode: e.errorCode
    };
  }

  if (e.status === 419) {
    return {
      error: 27,
      errorCode: e.errorCode
    };
  }

  if (e.status === 422) {
    return {
      error: -1,
      errorCode: e.errorCode
    };
  }

  if (e.status === 500) {
    return {
      error: 500,
      errorCode: e.errorCode
    };
  } // TODO! This is always a fatal error that should be logged && reported


  console.error('Unexpected error during API call!', e);
  return {
    error: -3,
    e: e
  };
}

function _logicError(desc, result) {
  console.error("Invalid return value for ".concat(desc), result);
  return {
    error: -2
  };
}

function _getResultError(result) {
  var emptyAllowed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (emptyAllowed && !result) {
    return;
  }

  if (!emptyAllowed && !result) {
    return {
      error: 9
    };
  }

  if (result.errors) {
    return {
      error: 6
    };
  }

  if (result.exception) {
    return {
      error: 7
    };
  }

  if (result.error) {
    return {
      error: 8
    };
  }

  return false;
}

var AvainiaCore = /*#__PURE__*/function () {
  function AvainiaCore(tokenReference) {
    _classCallCheck(this, AvainiaCore);

    var token;

    if (!tokenReference) {
      // Allow explicit usage without a token, the 401 catcher _should_ take care of it
      this.requestService = new NewRequestService(token);
      return;
    }

    if (typeof tokenReference === "function") {
      token = tokenReference();
    } else if (typeof tokenReference === "string") {
      // Stupid JS primitive typing, why can't I use instanceof String :(
      token = tokenReference;
    } else {
      throw Error("Invalid token argument, expected synchronous callback function or string");
    }

    if (token instanceof Promise) {
      throw Error("Token function must not be async");
    }

    this.token = token;
    this.requestService = new NewRequestService(token);
  }

  _createClass(AvainiaCore, [{
    key: "getCompanyUsers",
    value: function () {
      var _getCompanyUsers = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(id) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", this.requestService.get("companies/".concat(id, "/users")).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('getCompanyUsers', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getCompanyUsers(_x) {
        return _getCompanyUsers.apply(this, arguments);
      }

      return getCompanyUsers;
    }()
  }, {
    key: "getProject",
    value: function () {
      var _getProject = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(id) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", this.projectGet(id));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getProject(_x2) {
        return _getProject.apply(this, arguments);
      }

      return getProject;
    }()
  }, {
    key: "getPhaseCompanies",
    value: function () {
      var _getPhaseCompanies = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(phase) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", this.requestService.get("fields/2/keywords/".concat(phase.id, "/companies?per_page=9999")) // TODO: Let's hope the field ID never changes :skull:
                .then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('getPhaseCompanies', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getPhaseCompanies(_x3) {
        return _getPhaseCompanies.apply(this, arguments);
      }

      return getPhaseCompanies;
    }()
  }, {
    key: "removePhaseFromCompany",
    value: function () {
      var _removePhaseFromCompany = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(phase, company) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", this.requestService.delete("fields/2/keywords/".concat(phase.id, "/companies/").concat(company.id)) // TODO: Let's hope the ID never changes :skull:
                .then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('addPhaseToCompany', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function removePhaseFromCompany(_x4, _x5) {
        return _removePhaseFromCompany.apply(this, arguments);
      }

      return removePhaseFromCompany;
    }()
  }, {
    key: "addPhaseToCompany",
    value: function () {
      var _addPhaseToCompany = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(phase, company) {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt("return", this.requestService.post("fields/2/keywords/".concat(phase.id, "/companies"), company) // TODO: Let's hope the ID never changes :skull:
                .then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('addPhaseToCompany', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function addPhaseToCompany(_x6, _x7) {
        return _addPhaseToCompany.apply(this, arguments);
      }

      return addPhaseToCompany;
    }()
  }, {
    key: "createPhase",
    value: function () {
      var _createPhase = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(name) {
        var payload;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (name) {
                  _context6.next = 2;
                  break;
                }

                return _context6.abrupt("return", {
                  error: 'Invalid input, need name!'
                });

              case 2:
                payload = {
                  field_id: 2,
                  // TODO: Let's hope the ID never changes :skull:
                  text: name
                };
                return _context6.abrupt("return", this.requestService.post('fields/2/keywords', payload) // TODO: Let's hope the ID never changes :skull:
                .then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('createPhase', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function createPhase(_x8) {
        return _createPhase.apply(this, arguments);
      }

      return createPhase;
    }()
  }, {
    key: "savePhase",
    value: function () {
      var _savePhase = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(phase) {
        var payload;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (phase) {
                  _context7.next = 2;
                  break;
                }

                return _context7.abrupt("return", {
                  error: 'Invalid input, need phase!'
                });

              case 2:
                payload = {
                  text: phase.name,
                  field_d: 2,
                  // TODO: Let's hope the ID never changes :skull:
                  deactivated: phase.deactivated
                };
                return _context7.abrupt("return", this.requestService.put("fields/2/keywords/".concat(phase.id), payload) // TODO: Let's hope the ID never changes :skull:
                .then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('savePhase', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 4:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function savePhase(_x9) {
        return _savePhase.apply(this, arguments);
      }

      return savePhase;
    }()
  }, {
    key: "deletePhase",
    value: function () {
      var _deletePhase = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(phase) {
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                if (phase) {
                  _context8.next = 2;
                  break;
                }

                return _context8.abrupt("return", {
                  error: 'Invalid input, need phase!'
                });

              case 2:
                return _context8.abrupt("return", this.requestService.delete("fields/2/keywords/".concat(phase.id)) // TODO: Let's hope the ID never changes :skull:
                .then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('deletePhase', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 3:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function deletePhase(_x10) {
        return _deletePhase.apply(this, arguments);
      }

      return deletePhase;
    }()
  }, {
    key: "getAllPhases",
    value: function () {
      var _getAllPhases = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
        var dataAttribute,
            _args9 = arguments;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                dataAttribute = _args9.length > 0 && _args9[0] !== undefined ? _args9[0] : 'phases';
                return _context9.abrupt("return", this.requestService.get('fields/2/keywords?per_page=9999') // TODO: Let's hope the ID never changes :skull:
                .then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('getAllPhases', result);
                  }

                  result.data.sort(function (a, b) {
                    return a.text > b.text ? 1 : -1;
                  });
                  var phases = result.data.map(function (x) {
                    return {
                      id: x.id,
                      name: x.text,
                      deactivated: x.deactivated
                    };
                  });
                  return dataAttribute ? _defineProperty({}, dataAttribute, phases) : phases;
                }).catch(_catcherInTheCode));

              case 2:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function getAllPhases() {
        return _getAllPhases.apply(this, arguments);
      }

      return getAllPhases;
    }()
  }, {
    key: "getAllSubjects",
    value: function () {
      var _getAllSubjects = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
        var dataAttribute,
            _args10 = arguments;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                dataAttribute = _args10.length > 0 && _args10[0] !== undefined ? _args10[0] : 'subjects';
                return _context10.abrupt("return", this.requestService.get('fields/3/keywords?per_page=9999').then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('getAllSubjects', result);
                  }

                  result.data.sort(function (a, b) {
                    return a.text > b.text ? 1 : -1;
                  });
                  var subjects = result.data.map(function (x) {
                    return {
                      id: x.id,
                      name: x.text
                    };
                  });
                  return dataAttribute ? _defineProperty({}, dataAttribute, subjects) : subjects;
                }).catch(_catcherInTheCode));

              case 2:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function getAllSubjects() {
        return _getAllSubjects.apply(this, arguments);
      }

      return getAllSubjects;
    }()
  }, {
    key: "getAllStates",
    value: function () {
      var _getAllStates = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
        var dataAttribute,
            _args11 = arguments;
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                dataAttribute = _args11.length > 0 && _args11[0] !== undefined ? _args11[0] : 'states';
                return _context11.abrupt("return", this.requestService.get('fields/4/keywords?per_page=9999') // TODO: Let's hope the ID never changes :skull:
                .then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('getAllStates', result);
                  }

                  result.data.sort(function (a, b) {
                    return a.text > b.text ? 1 : -1;
                  });
                  var states = result.data.map(function (x) {
                    return {
                      id: x.id,
                      name: x.text
                    };
                  });
                  return dataAttribute ? _defineProperty({}, dataAttribute, states) : states;
                }).catch(_catcherInTheCode));

              case 2:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function getAllStates() {
        return _getAllStates.apply(this, arguments);
      }

      return getAllStates;
    }()
  }, {
    key: "getFields",
    value: function () {
      var _getFields = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
        var dataAttribute,
            _args12 = arguments;
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                dataAttribute = _args12.length > 0 && _args12[0] !== undefined ? _args12[0] : 'fields';
                return _context12.abrupt("return", this.requestService.get('fields?per_page=9999').then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    _logicError('getFields', result);
                  }

                  return dataAttribute ? _defineProperty({}, dataAttribute, result.data) : result.data;
                }).catch(_catcherInTheCode));

              case 2:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function getFields() {
        return _getFields.apply(this, arguments);
      }

      return getFields;
    }()
  }, {
    key: "deleteUser",
    value: function () {
      var _deleteUser = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(user) {
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                if (user) {
                  _context13.next = 2;
                  break;
                }

                return _context13.abrupt("return", {
                  error: 'Invalid input, need user!'
                });

              case 2:
                return _context13.abrupt("return", this.requestService.delete("users/".concat(user.id)).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('deleteUser', result);
                  }

                  return result;
                }).catch(_catcherInTheCode));

              case 3:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function deleteUser(_x11) {
        return _deleteUser.apply(this, arguments);
      }

      return deleteUser;
    }()
  }, {
    key: "documentReplace",
    value: function () {
      var _documentReplace = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(projectId, documentId, fileId, payload) {
        var BaseURL, endpoint, options, data;
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                if (!(!payload || !payload.file)) {
                  _context15.next = 2;
                  break;
                }

                return _context15.abrupt("return", {
                  error: 'Guru Meditation: Payload must contain a file'
                });

              case 2:
                BaseURL = "".concat(process.env.REACT_APP_API_HOST, "/api/v1/");
                endpoint = "".concat(BaseURL, "projects/").concat(projectId, "/documents/").concat(documentId, "/files/").concat(fileId, "/replace");
                options = {
                  indices: true,
                  nullsAsUndefineds: false,
                  booleansAsIntegers: false
                };
                data = {
                  method: 'POST',
                  body: objectToFormData(payload, options),
                  headers: {
                    Accept: 'application/json'
                  }
                };

                if (this.token) {
                  data.headers.Authorization = "Bearer ".concat(this.token);
                }

                return _context15.abrupt("return", fetch(endpoint, data).then( /*#__PURE__*/function () {
                  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(response) {
                    var json;
                    return _regeneratorRuntime.wrap(function _callee14$(_context14) {
                      while (1) {
                        switch (_context14.prev = _context14.next) {
                          case 0:
                            if (!(response.status > 299 || response.status < 199)) {
                              _context14.next = 2;
                              break;
                            }

                            return _context14.abrupt("return", _catcherInTheCode(response));

                          case 2:
                            _context14.prev = 2;

                            if (!response.json) {
                              _context14.next = 9;
                              break;
                            }

                            _context14.next = 6;
                            return response.json();

                          case 6:
                            _context14.t0 = _context14.sent;
                            _context14.next = 10;
                            break;

                          case 9:
                            _context14.t0 = null;

                          case 10:
                            json = _context14.t0;
                            _context14.next = 16;
                            break;

                          case 13:
                            _context14.prev = 13;
                            _context14.t1 = _context14["catch"](2);
                            console.warn('Unable to parse JSON from API response', _context14.t1);

                          case 16:
                            return _context14.abrupt("return", json.data ? json.data : json);

                          case 17:
                          case "end":
                            return _context14.stop();
                        }
                      }
                    }, _callee14, null, [[2, 13]]);
                  }));

                  return function (_x16) {
                    return _ref5.apply(this, arguments);
                  };
                }()).catch(_catcherInTheCode));

              case 8:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));

      function documentReplace(_x12, _x13, _x14, _x15) {
        return _documentReplace.apply(this, arguments);
      }

      return documentReplace;
    }()
  }, {
    key: "documentAdd",
    value: function () {
      var _documentAdd = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17(payload) {
        var BaseURL, endpoint, options, data;
        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                BaseURL = "".concat(process.env.REACT_APP_API_HOST, "/api/v1/"); //TODO! EXTRACT OUT!

                endpoint = "".concat(BaseURL, "projects/").concat(payload.projectId, "/documents");
                options = {
                  indices: true,
                  nullsAsUndefineds: false,
                  booleansAsIntegers: false
                };
                data = {
                  method: 'POST',
                  body: objectToFormData(payload, options),
                  headers: {
                    Accept: 'application/json'
                  }
                };

                if (this.token) {
                  data.headers.Authorization = "Bearer ".concat(this.token);
                }

                return _context17.abrupt("return", fetch(endpoint, data).then( /*#__PURE__*/function () {
                  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(response) {
                    var json;
                    return _regeneratorRuntime.wrap(function _callee16$(_context16) {
                      while (1) {
                        switch (_context16.prev = _context16.next) {
                          case 0:
                            if (!(response.status > 299 || response.status < 199)) {
                              _context16.next = 2;
                              break;
                            }

                            return _context16.abrupt("return", _catcherInTheCode(response));

                          case 2:
                            _context16.prev = 2;

                            if (!response.json) {
                              _context16.next = 9;
                              break;
                            }

                            _context16.next = 6;
                            return response.json();

                          case 6:
                            _context16.t0 = _context16.sent;
                            _context16.next = 10;
                            break;

                          case 9:
                            _context16.t0 = null;

                          case 10:
                            json = _context16.t0;
                            _context16.next = 16;
                            break;

                          case 13:
                            _context16.prev = 13;
                            _context16.t1 = _context16["catch"](2);
                            console.warn('Unable to parse JSON from API response', _context16.t1);

                          case 16:
                            return _context16.abrupt("return", json.data ? json.data : json);

                          case 17:
                          case "end":
                            return _context16.stop();
                        }
                      }
                    }, _callee16, null, [[2, 13]]);
                  }));

                  return function (_x18) {
                    return _ref6.apply(this, arguments);
                  };
                }()).catch(_catcherInTheCode));

              case 6:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this);
      }));

      function documentAdd(_x17) {
        return _documentAdd.apply(this, arguments);
      }

      return documentAdd;
    }()
  }, {
    key: "createFileExportJob",
    value: function () {
      var _createFileExportJob = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(payload) {
        return _regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                return _context18.abrupt("return", this.requestService.post("projects/".concat(payload.projectId, "/files-zip"), payload).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (result.code !== 200) {
                    return _logicError('createFileExportJob');
                  }

                  return result;
                }).catch(function (e) {
                  return _catcherInTheCode(e);
                }));

              case 1:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, this);
      }));

      function createFileExportJob(_x19) {
        return _createFileExportJob.apply(this, arguments);
      }

      return createFileExportJob;
    }()
  }, {
    key: "acceptTerms",
    value: function () {
      var _acceptTerms = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19() {
        return _regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                return _context19.abrupt("return", this.requestService.post('acceptedprivacyterms', {}).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result) {
                    return _logicError('acceptTerms');
                  }

                  return true;
                }).catch(function (e) {
                  return _catcherInTheCode(e, true);
                }));

              case 1:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, this);
      }));

      function acceptTerms() {
        return _acceptTerms.apply(this, arguments);
      }

      return acceptTerms;
    }()
  }, {
    key: "doUpdateFolder",
    value: function () {
      var _doUpdateFolder = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20(project, docId, newFolderId) {
        var newProjectId,
            _args20 = arguments;
        return _regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                newProjectId = _args20.length > 3 && _args20[3] !== undefined ? _args20[3] : null;
                _context20.next = 3;
                return this.requestService.updateFolder("projects/".concat(project.id, "/documents/").concat(docId, "/updateFolder"), newFolderId, newProjectId).then(function (result) {
                  if (_getResultError(result, false)) {
                    return _getResultError(result, false);
                  }

                  return true;
                }).catch(_catcherInTheCode);

              case 3:
                return _context20.abrupt("return", _context20.sent);

              case 4:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20, this);
      }));

      function doUpdateFolder(_x20, _x21, _x22) {
        return _doUpdateFolder.apply(this, arguments);
      }

      return doUpdateFolder;
    }()
  }, {
    key: "doSaveEditedImage",
    value: function () {
      var _doSaveEditedImage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee21(project, docId, payload) {
        return _regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                _context21.next = 2;
                return this.requestService.put("projects/".concat(project.id, "/documents/").concat(docId), payload).then(function (result) {
                  if (_getResultError(result, false)) {
                    return _getResultError(result, false);
                  }

                  return true;
                }).catch(_catcherInTheCode);

              case 2:
                return _context21.abrupt("return", _context21.sent);

              case 3:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21, this);
      }));

      function doSaveEditedImage(_x23, _x24, _x25) {
        return _doSaveEditedImage.apply(this, arguments);
      }

      return doSaveEditedImage;
    }()
  }, {
    key: "doDeleteDocument",
    value: function () {
      var _doDeleteDocument = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee22(project, document) {
        return _regeneratorRuntime.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                _context22.next = 2;
                return this.requestService.delete("projects/".concat(project.id, "/documents/").concat(document.id), document).then(function (result) {
                  if (_getResultError(result, false)) {
                    return _getResultError(result, false);
                  }

                  return true;
                }).catch(_catcherInTheCode);

              case 2:
                return _context22.abrupt("return", _context22.sent);

              case 3:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22, this);
      }));

      function doDeleteDocument(_x26, _x27) {
        return _doDeleteDocument.apply(this, arguments);
      }

      return doDeleteDocument;
    }()
  }, {
    key: "doImportData",
    value: function () {
      var _doImportData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee23(data) {
        return _regeneratorRuntime.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                _context23.next = 2;
                return this.requestService.post('import', data).then(function (result) {
                  return result;
                }).catch(_catcherInTheCode);

              case 2:
                return _context23.abrupt("return", _context23.sent);

              case 3:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23, this);
      }));

      function doImportData(_x28) {
        return _doImportData.apply(this, arguments);
      }

      return doImportData;
    }()
    /* Rows below this comment have updated naming */

  }, {
    key: "login",
    value: function () {
      var _login = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee24(email, password, isPortal) {
        return _regeneratorRuntime.wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                if (!(!email || !password)) {
                  _context24.next = 2;
                  break;
                }

                return _context24.abrupt("return", {
                  error: 'Input error'
                });

              case 2:
                return _context24.abrupt("return", this.requestService.post('authenticate', {
                  email: email,
                  password: password,
                  isPortal: isPortal
                }).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data || !result.data.user) {
                    return _logicError('doLogin');
                  }

                  var user = result.data.user;
                  user.token = result.data.token;
                  return user;
                }).catch(function (e) {
                  return _catcherInTheCode(e, true);
                }));

              case 3:
              case "end":
                return _context24.stop();
            }
          }
        }, _callee24, this);
      }));

      function login(_x29, _x30, _x31) {
        return _login.apply(this, arguments);
      }

      return login;
    }()
  }, {
    key: "loginCheck",
    value: function () {
      var _loginCheck = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee25() {
        return _regeneratorRuntime.wrap(function _callee25$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                return _context25.abrupt("return", this.requestService.get('user').then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('loginCheck', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context25.stop();
            }
          }
        }, _callee25, this);
      }));

      function loginCheck() {
        return _loginCheck.apply(this, arguments);
      }

      return loginCheck;
    }()
  }, {
    key: "condominiumsInfoGet",
    value: function () {
      var _condominiumsInfoGet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee26() {
        return _regeneratorRuntime.wrap(function _callee26$(_context26) {
          while (1) {
            switch (_context26.prev = _context26.next) {
              case 0:
                return _context26.abrupt("return", this.requestService.get('condominiumsInfo').then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result) {
                    return _logicError('condominiumsInfo', result);
                  }

                  return result;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context26.stop();
            }
          }
        }, _callee26, this);
      }));

      function condominiumsInfoGet() {
        return _condominiumsInfoGet.apply(this, arguments);
      }

      return condominiumsInfoGet;
    }()
  }, {
    key: "apartmentMaterialquotesGet",
    value: function () {
      var _apartmentMaterialquotesGet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee27(id) {
        return _regeneratorRuntime.wrap(function _callee27$(_context27) {
          while (1) {
            switch (_context27.prev = _context27.next) {
              case 0:
                return _context27.abrupt("return", this.requestService.get("apartments/".concat(id, "/materialquotes")).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('apartmentMaterialquotesGet', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context27.stop();
            }
          }
        }, _callee27, this);
      }));

      function apartmentMaterialquotesGet(_x32) {
        return _apartmentMaterialquotesGet.apply(this, arguments);
      }

      return apartmentMaterialquotesGet;
    }()
  }, {
    key: "getOpenQuotesByApartment",
    value: function () {
      var _getOpenQuotesByApartment = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee28(id, dataAttribute) {
        return _regeneratorRuntime.wrap(function _callee28$(_context28) {
          while (1) {
            switch (_context28.prev = _context28.next) {
              case 0:
                return _context28.abrupt("return", this.requestService.get("apartments/".concat(id, "/openquotesbyapartment")).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('apartmentMaterialquotesGet', result);
                  }

                  return dataAttribute ? _defineProperty({}, dataAttribute, result.data) : result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context28.stop();
            }
          }
        }, _callee28, this);
      }));

      function getOpenQuotesByApartment(_x33, _x34) {
        return _getOpenQuotesByApartment.apply(this, arguments);
      }

      return getOpenQuotesByApartment;
    }()
  }, {
    key: "materialQuoteMarkAsRead",
    value: function () {
      var _materialQuoteMarkAsRead = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee29(id, payload, dataAttribute) {
        return _regeneratorRuntime.wrap(function _callee29$(_context29) {
          while (1) {
            switch (_context29.prev = _context29.next) {
              case 0:
                return _context29.abrupt("return", this.requestService.post("materialquotes/".concat(id, "/mark-as-read"), payload).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('materialQuoteMarkAsRead', result);
                  }

                  return dataAttribute ? _defineProperty({}, dataAttribute, result.data) : result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context29.stop();
            }
          }
        }, _callee29, this);
      }));

      function materialQuoteMarkAsRead(_x35, _x36, _x37) {
        return _materialQuoteMarkAsRead.apply(this, arguments);
      }

      return materialQuoteMarkAsRead;
    }()
  }, {
    key: "apartmentMaterialquoteSendCorrections",
    value: function () {
      var _apartmentMaterialquoteSendCorrections = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee30(id, payload) {
        return _regeneratorRuntime.wrap(function _callee30$(_context30) {
          while (1) {
            switch (_context30.prev = _context30.next) {
              case 0:
                return _context30.abrupt("return", this.requestService.post("materialquotes/".concat(id, "/send-corrections"), payload).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('apartmentMaterialquoteSendCorrections', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context30.stop();
            }
          }
        }, _callee30, this);
      }));

      function apartmentMaterialquoteSendCorrections(_x38, _x39) {
        return _apartmentMaterialquoteSendCorrections.apply(this, arguments);
      }

      return apartmentMaterialquoteSendCorrections;
    }()
  }, {
    key: "apartmentMaterialquoteApprove",
    value: function () {
      var _apartmentMaterialquoteApprove = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee31(id, payload) {
        return _regeneratorRuntime.wrap(function _callee31$(_context31) {
          while (1) {
            switch (_context31.prev = _context31.next) {
              case 0:
                return _context31.abrupt("return", this.requestService.post("materialquotes/".concat(id, "/approve"), payload).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('apartmentMaterialquoteApprove', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context31.stop();
            }
          }
        }, _callee31, this);
      }));

      function apartmentMaterialquoteApprove(_x40, _x41) {
        return _apartmentMaterialquoteApprove.apply(this, arguments);
      }

      return apartmentMaterialquoteApprove;
    }()
  }, {
    key: "materialQuoteCommentAdd",
    value: function () {
      var _materialQuoteCommentAdd = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee32(quoteId, payload, dataAttribute) {
        return _regeneratorRuntime.wrap(function _callee32$(_context32) {
          while (1) {
            switch (_context32.prev = _context32.next) {
              case 0:
                return _context32.abrupt("return", this.requestService.post("material-quote-comments/quote/".concat(quoteId), payload).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('materialQuoteCommentAdd', result);
                  }

                  return dataAttribute ? _defineProperty({}, dataAttribute, result.data) : result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context32.stop();
            }
          }
        }, _callee32, this);
      }));

      function materialQuoteCommentAdd(_x42, _x43, _x44) {
        return _materialQuoteCommentAdd.apply(this, arguments);
      }

      return materialQuoteCommentAdd;
    }()
  }, {
    key: "materialQuoteCommentsGet",
    value: function () {
      var _materialQuoteCommentsGet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee33(quoteId, dataAttribute) {
        return _regeneratorRuntime.wrap(function _callee33$(_context33) {
          while (1) {
            switch (_context33.prev = _context33.next) {
              case 0:
                return _context33.abrupt("return", this.requestService.get("material-quote-comments/quote/".concat(quoteId)).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('materialQuoteCommentsGet', result);
                  }

                  return dataAttribute ? _defineProperty({}, dataAttribute, result.data) : result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context33.stop();
            }
          }
        }, _callee33, this);
      }));

      function materialQuoteCommentsGet(_x45, _x46) {
        return _materialQuoteCommentsGet.apply(this, arguments);
      }

      return materialQuoteCommentsGet;
    }()
  }, {
    key: "condominiumsGet",
    value: function () {
      var _condominiumsGet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee34(dataAttribute) {
        return _regeneratorRuntime.wrap(function _callee34$(_context34) {
          while (1) {
            switch (_context34.prev = _context34.next) {
              case 0:
                return _context34.abrupt("return", this.requestService.get('condominiums?per_page=9999').then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('condominiumsGet', result);
                  }

                  return dataAttribute ? _defineProperty({}, dataAttribute, result.data) : result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context34.stop();
            }
          }
        }, _callee34, this);
      }));

      function condominiumsGet(_x47) {
        return _condominiumsGet.apply(this, arguments);
      }

      return condominiumsGet;
    }()
  }, {
    key: "condominiumProjectsGet",
    value: function () {
      var _condominiumProjectsGet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee35(id) {
        return _regeneratorRuntime.wrap(function _callee35$(_context35) {
          while (1) {
            switch (_context35.prev = _context35.next) {
              case 0:
                return _context35.abrupt("return", this.requestService.get("condominiums/".concat(id, "/projects")).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('condominiumsGet', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context35.stop();
            }
          }
        }, _callee35, this);
      }));

      function condominiumProjectsGet(_x48) {
        return _condominiumProjectsGet.apply(this, arguments);
      }

      return condominiumProjectsGet;
    }()
  }, {
    key: "condominiumEdit",
    value: function () {
      var _condominiumEdit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee36(payload) {
        return _regeneratorRuntime.wrap(function _callee36$(_context36) {
          while (1) {
            switch (_context36.prev = _context36.next) {
              case 0:
                return _context36.abrupt("return", this.requestService.put("condominiums/".concat(payload.id), payload).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('condominiumEdit', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context36.stop();
            }
          }
        }, _callee36, this);
      }));

      function condominiumEdit(_x49) {
        return _condominiumEdit.apply(this, arguments);
      }

      return condominiumEdit;
    }()
  }, {
    key: "condominiumCreate",
    value: function () {
      var _condominiumCreate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee37(payload) {
        return _regeneratorRuntime.wrap(function _callee37$(_context37) {
          while (1) {
            switch (_context37.prev = _context37.next) {
              case 0:
                return _context37.abrupt("return", this.requestService.post('condominiums', payload).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('condominiumsCreate', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context37.stop();
            }
          }
        }, _callee37, this);
      }));

      function condominiumCreate(_x50) {
        return _condominiumCreate.apply(this, arguments);
      }

      return condominiumCreate;
    }()
  }, {
    key: "condominiumDelete",
    value: function () {
      var _condominiumDelete = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee38(payload) {
        return _regeneratorRuntime.wrap(function _callee38$(_context38) {
          while (1) {
            switch (_context38.prev = _context38.next) {
              case 0:
                return _context38.abrupt("return", this.requestService.delete("condominiums/".concat(payload.id)).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('condominiumDelete', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context38.stop();
            }
          }
        }, _callee38, this);
      }));

      function condominiumDelete(_x51) {
        return _condominiumDelete.apply(this, arguments);
      }

      return condominiumDelete;
    }()
  }, {
    key: "condominiumGet",
    value: function () {
      var _condominiumGet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee39(id, dataAttribute) {
        return _regeneratorRuntime.wrap(function _callee39$(_context39) {
          while (1) {
            switch (_context39.prev = _context39.next) {
              case 0:
                return _context39.abrupt("return", this.requestService.get("condominiums/".concat(id)).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('condominiumsGet', result);
                  }

                  return dataAttribute ? _defineProperty({}, dataAttribute, result.data) : result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context39.stop();
            }
          }
        }, _callee39, this);
      }));

      function condominiumGet(_x52, _x53) {
        return _condominiumGet.apply(this, arguments);
      }

      return condominiumGet;
    }()
  }, {
    key: "condominiumMainPhotoGet",
    value: function () {
      var _condominiumMainPhotoGet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee40(id) {
        return _regeneratorRuntime.wrap(function _callee40$(_context40) {
          while (1) {
            switch (_context40.prev = _context40.next) {
              case 0:
                return _context40.abrupt("return", this.requestService.getImage("condominium/photo/".concat(id)).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result) {
                    return _logicError('userPhotoGet', result);
                  }

                  return new Promise(function (resolve, reject) {
                    var reader = new FileReader();
                    reader.readAsDataURL(result);

                    reader.onloadend = function () {
                      resolve(reader.result);
                    };
                  });
                }).catch(function () {
                  return {
                    error: true
                  };
                }));

              case 1:
              case "end":
                return _context40.stop();
            }
          }
        }, _callee40, this);
      }));

      function condominiumMainPhotoGet(_x54) {
        return _condominiumMainPhotoGet.apply(this, arguments);
      }

      return condominiumMainPhotoGet;
    }()
  }, {
    key: "condominiumMainPhotoCreate",
    value: function () {
      var _condominiumMainPhotoCreate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee41(condominiumId, photo) {
        return _regeneratorRuntime.wrap(function _callee41$(_context41) {
          while (1) {
            switch (_context41.prev = _context41.next) {
              case 0:
                return _context41.abrupt("return", this.requestService.postPhoto("condominium/photo/".concat(condominiumId), photo).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result) {
                    return _logicError('userPhotoUpdate', result);
                  }

                  return result;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context41.stop();
            }
          }
        }, _callee41, this);
      }));

      function condominiumMainPhotoCreate(_x55, _x56) {
        return _condominiumMainPhotoCreate.apply(this, arguments);
      }

      return condominiumMainPhotoCreate;
    }()
  }, {
    key: "condominiumMainPhotoDelete",
    value: function () {
      var _condominiumMainPhotoDelete = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee42(id) {
        return _regeneratorRuntime.wrap(function _callee42$(_context42) {
          while (1) {
            switch (_context42.prev = _context42.next) {
              case 0:
                return _context42.abrupt("return", this.requestService.delete("condominium/photo/".concat(id)).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result) {
                    return _logicError('userPhotoDelete', result);
                  }

                  return result;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context42.stop();
            }
          }
        }, _callee42, this);
      }));

      function condominiumMainPhotoDelete(_x57) {
        return _condominiumMainPhotoDelete.apply(this, arguments);
      }

      return condominiumMainPhotoDelete;
    }()
  }, {
    key: "condominiumApartmentsGet",
    value: function () {
      var _condominiumApartmentsGet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee43(id, dataAttribute) {
        return _regeneratorRuntime.wrap(function _callee43$(_context43) {
          while (1) {
            switch (_context43.prev = _context43.next) {
              case 0:
                return _context43.abrupt("return", this.requestService.get("condominiums/".concat(id, "/apartments")).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('condominiumApartmentsGet', result);
                  }

                  return dataAttribute ? _defineProperty({}, dataAttribute, result.data) : result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context43.stop();
            }
          }
        }, _callee43, this);
      }));

      function condominiumApartmentsGet(_x58, _x59) {
        return _condominiumApartmentsGet.apply(this, arguments);
      }

      return condominiumApartmentsGet;
    }()
  }, {
    key: "condominiumApartmentGet",
    value: function () {
      var _condominiumApartmentGet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee44(condominiumId, apartmentId, dataAttribute) {
        return _regeneratorRuntime.wrap(function _callee44$(_context44) {
          while (1) {
            switch (_context44.prev = _context44.next) {
              case 0:
                return _context44.abrupt("return", this.requestService.get("condominiums/".concat(condominiumId, "/apartments/").concat(apartmentId)).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('condominiumApartmentGet', result);
                  }

                  return dataAttribute ? _defineProperty({}, dataAttribute, result.data) : result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context44.stop();
            }
          }
        }, _callee44, this);
      }));

      function condominiumApartmentGet(_x60, _x61, _x62) {
        return _condominiumApartmentGet.apply(this, arguments);
      }

      return condominiumApartmentGet;
    }()
  }, {
    key: "condominiumApartmentCreate",
    value: function () {
      var _condominiumApartmentCreate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee45(id, payload) {
        return _regeneratorRuntime.wrap(function _callee45$(_context45) {
          while (1) {
            switch (_context45.prev = _context45.next) {
              case 0:
                return _context45.abrupt("return", this.requestService.post("condominiums/".concat(id, "/apartments"), payload).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('condominiumApartmentCreate', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context45.stop();
            }
          }
        }, _callee45, this);
      }));

      function condominiumApartmentCreate(_x63, _x64) {
        return _condominiumApartmentCreate.apply(this, arguments);
      }

      return condominiumApartmentCreate;
    }()
  }, {
    key: "condominiumApartmentDelete",
    value: function () {
      var _condominiumApartmentDelete = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee46(id, aptid) {
        return _regeneratorRuntime.wrap(function _callee46$(_context46) {
          while (1) {
            switch (_context46.prev = _context46.next) {
              case 0:
                return _context46.abrupt("return", this.requestService.delete("condominiums/".concat(id, "/apartments/").concat(aptid)).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('condominiumApartmentDelete', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context46.stop();
            }
          }
        }, _callee46, this);
      }));

      function condominiumApartmentDelete(_x65, _x66) {
        return _condominiumApartmentDelete.apply(this, arguments);
      }

      return condominiumApartmentDelete;
    }()
  }, {
    key: "condominiumApartmentTemplateMaterialformsGet",
    value: function () {
      var _condominiumApartmentTemplateMaterialformsGet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee47(id, dataAttribute) {
        return _regeneratorRuntime.wrap(function _callee47$(_context47) {
          while (1) {
            switch (_context47.prev = _context47.next) {
              case 0:
                return _context47.abrupt("return", this.requestService.get("apartmenttemplates/".concat(id, "/materialforms")).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('condominiumApartmentTemplateMaterialformsGet', result);
                  }

                  return dataAttribute ? _defineProperty({}, dataAttribute, result.data) : result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context47.stop();
            }
          }
        }, _callee47, this);
      }));

      function condominiumApartmentTemplateMaterialformsGet(_x67, _x68) {
        return _condominiumApartmentTemplateMaterialformsGet.apply(this, arguments);
      }

      return condominiumApartmentTemplateMaterialformsGet;
    }()
  }, {
    key: "condominiumApartmentTemplateMaterialformsWithSubmissionFormsGet",
    value: function () {
      var _condominiumApartmentTemplateMaterialformsWithSubmissionFormsGet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee48(id, apartmentId, dataAttribute) {
        return _regeneratorRuntime.wrap(function _callee48$(_context48) {
          while (1) {
            switch (_context48.prev = _context48.next) {
              case 0:
                return _context48.abrupt("return", this.requestService.get("apartmenttemplates/".concat(id, "/materialforms-with-submissions/").concat(apartmentId)).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result) {
                    return _logicError('condominiumApartmentTemplateMaterialformsWithSubmissionFormsGet', result);
                  }

                  return dataAttribute ? _defineProperty({}, dataAttribute, result) : result;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context48.stop();
            }
          }
        }, _callee48, this);
      }));

      function condominiumApartmentTemplateMaterialformsWithSubmissionFormsGet(_x69, _x70, _x71) {
        return _condominiumApartmentTemplateMaterialformsWithSubmissionFormsGet.apply(this, arguments);
      }

      return condominiumApartmentTemplateMaterialformsWithSubmissionFormsGet;
    }()
  }, {
    key: "condominiumApartmentTemplateMaterialformsCreate",
    value: function () {
      var _condominiumApartmentTemplateMaterialformsCreate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee49(id, payload) {
        return _regeneratorRuntime.wrap(function _callee49$(_context49) {
          while (1) {
            switch (_context49.prev = _context49.next) {
              case 0:
                return _context49.abrupt("return", this.requestService.post("apartmenttemplates/".concat(id, "/materialforms"), payload).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('condominiumApartmentTemplateMaterialformsCreate', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context49.stop();
            }
          }
        }, _callee49, this);
      }));

      function condominiumApartmentTemplateMaterialformsCreate(_x72, _x73) {
        return _condominiumApartmentTemplateMaterialformsCreate.apply(this, arguments);
      }

      return condominiumApartmentTemplateMaterialformsCreate;
    }()
  }, {
    key: "condominiumApartmentTemplateMaterialformsDelete",
    value: function () {
      var _condominiumApartmentTemplateMaterialformsDelete = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee50(apartmentTemplateId, materialformId) {
        return _regeneratorRuntime.wrap(function _callee50$(_context50) {
          while (1) {
            switch (_context50.prev = _context50.next) {
              case 0:
                return _context50.abrupt("return", this.requestService.delete("apartmenttemplates/".concat(apartmentTemplateId, "/materialforms/").concat(materialformId)).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('condominiumApartmentTemplateMaterialformsDelete', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context50.stop();
            }
          }
        }, _callee50, this);
      }));

      function condominiumApartmentTemplateMaterialformsDelete(_x74, _x75) {
        return _condominiumApartmentTemplateMaterialformsDelete.apply(this, arguments);
      }

      return condominiumApartmentTemplateMaterialformsDelete;
    }()
  }, {
    key: "condominiumApartmentTemplatesGet",
    value: function () {
      var _condominiumApartmentTemplatesGet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee51(id, dataAttribute) {
        return _regeneratorRuntime.wrap(function _callee51$(_context51) {
          while (1) {
            switch (_context51.prev = _context51.next) {
              case 0:
                return _context51.abrupt("return", this.requestService.get("condominiums/".concat(id, "/apartmenttemplates")).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('condominiumApartmentTemplatesGet', result);
                  }

                  return dataAttribute ? _defineProperty({}, dataAttribute, result.data) : result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context51.stop();
            }
          }
        }, _callee51, this);
      }));

      function condominiumApartmentTemplatesGet(_x76, _x77) {
        return _condominiumApartmentTemplatesGet.apply(this, arguments);
      }

      return condominiumApartmentTemplatesGet;
    }()
  }, {
    key: "condominiumApartmentTemplateCreate",
    value: function () {
      var _condominiumApartmentTemplateCreate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee52(id, name) {
        var payload;
        return _regeneratorRuntime.wrap(function _callee52$(_context52) {
          while (1) {
            switch (_context52.prev = _context52.next) {
              case 0:
                payload = {
                  name: name
                };
                return _context52.abrupt("return", this.requestService.post("condominiums/".concat(id, "/apartmenttemplates"), payload).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('condominiumApartmentTemplateCreate', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 2:
              case "end":
                return _context52.stop();
            }
          }
        }, _callee52, this);
      }));

      function condominiumApartmentTemplateCreate(_x78, _x79) {
        return _condominiumApartmentTemplateCreate.apply(this, arguments);
      }

      return condominiumApartmentTemplateCreate;
    }()
  }, {
    key: "condominiumApartmentTemplateGet",
    value: function () {
      var _condominiumApartmentTemplateGet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee53(condoid, templateid, dataAttribute) {
        return _regeneratorRuntime.wrap(function _callee53$(_context53) {
          while (1) {
            switch (_context53.prev = _context53.next) {
              case 0:
                return _context53.abrupt("return", this.requestService.get("condominiums/".concat(condoid, "/apartmenttemplates/").concat(templateid)).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('condominiumApartmentTemplateGet', result);
                  }

                  return dataAttribute ? _defineProperty({}, dataAttribute, result.data) : result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context53.stop();
            }
          }
        }, _callee53, this);
      }));

      function condominiumApartmentTemplateGet(_x80, _x81, _x82) {
        return _condominiumApartmentTemplateGet.apply(this, arguments);
      }

      return condominiumApartmentTemplateGet;
    }()
  }, {
    key: "condominiumApartmentTemplateDelete",
    value: function () {
      var _condominiumApartmentTemplateDelete = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee54(condoid, templateid) {
        return _regeneratorRuntime.wrap(function _callee54$(_context54) {
          while (1) {
            switch (_context54.prev = _context54.next) {
              case 0:
                return _context54.abrupt("return", this.requestService.delete("condominiums/".concat(condoid, "/apartmenttemplates/").concat(templateid)).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('condominiumApartmentTemplateDelete', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context54.stop();
            }
          }
        }, _callee54, this);
      }));

      function condominiumApartmentTemplateDelete(_x83, _x84) {
        return _condominiumApartmentTemplateDelete.apply(this, arguments);
      }

      return condominiumApartmentTemplateDelete;
    }()
  }, {
    key: "condominiumApartmentTemplateEdit",
    value: function () {
      var _condominiumApartmentTemplateEdit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee55(condoid, templateid, payload) {
        return _regeneratorRuntime.wrap(function _callee55$(_context55) {
          while (1) {
            switch (_context55.prev = _context55.next) {
              case 0:
                return _context55.abrupt("return", this.requestService.put("condominiums/".concat(condoid, "/apartmenttemplates/").concat(templateid), payload).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('condominiumApartmentTemplateEdit', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context55.stop();
            }
          }
        }, _callee55, this);
      }));

      function condominiumApartmentTemplateEdit(_x85, _x86, _x87) {
        return _condominiumApartmentTemplateEdit.apply(this, arguments);
      }

      return condominiumApartmentTemplateEdit;
    }()
  }, {
    key: "condominiumBasedOnApartmentGet",
    value: function () {
      var _condominiumBasedOnApartmentGet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee56(apartmentId, dataAttribute) {
        return _regeneratorRuntime.wrap(function _callee56$(_context56) {
          while (1) {
            switch (_context56.prev = _context56.next) {
              case 0:
                return _context56.abrupt("return", this.requestService.get("apartments/condominium/".concat(apartmentId)).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('condominiumBasedOnApartmentGet', result);
                  }

                  return dataAttribute ? _defineProperty({}, dataAttribute, result.data) : result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context56.stop();
            }
          }
        }, _callee56, this);
      }));

      function condominiumBasedOnApartmentGet(_x88, _x89) {
        return _condominiumBasedOnApartmentGet.apply(this, arguments);
      }

      return condominiumBasedOnApartmentGet;
    }()
  }, {
    key: "condominiumApartmentsGetByApartmentId",
    value: function () {
      var _condominiumApartmentsGetByApartmentId = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee57(apartmentId, dataAttribute) {
        return _regeneratorRuntime.wrap(function _callee57$(_context57) {
          while (1) {
            switch (_context57.prev = _context57.next) {
              case 0:
                return _context57.abrupt("return", this.requestService.get("apartment/".concat(apartmentId, "/condominium/")).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('condominiumApartmentsGetByApartmentId', result);
                  }

                  return dataAttribute ? _defineProperty({}, dataAttribute, result.data) : result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context57.stop();
            }
          }
        }, _callee57, this);
      }));

      function condominiumApartmentsGetByApartmentId(_x90, _x91) {
        return _condominiumApartmentsGetByApartmentId.apply(this, arguments);
      }

      return condominiumApartmentsGetByApartmentId;
    }()
  }, {
    key: "defaultFoldersGet",
    value: function () {
      var _defaultFoldersGet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee58(dataAttribute) {
        return _regeneratorRuntime.wrap(function _callee58$(_context58) {
          while (1) {
            switch (_context58.prev = _context58.next) {
              case 0:
                return _context58.abrupt("return", this.requestService.get('defaultfolders').then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('defaultFoldersGet', result);
                  }

                  return dataAttribute ? _defineProperty({}, dataAttribute, result.data) : result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context58.stop();
            }
          }
        }, _callee58, this);
      }));

      function defaultFoldersGet(_x92) {
        return _defaultFoldersGet.apply(this, arguments);
      }

      return defaultFoldersGet;
    }()
  }, {
    key: "defaultFoldersCreate",
    value: function () {
      var _defaultFoldersCreate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee59(defaultfolder, dataAttribute) {
        return _regeneratorRuntime.wrap(function _callee59$(_context59) {
          while (1) {
            switch (_context59.prev = _context59.next) {
              case 0:
                return _context59.abrupt("return", this.requestService.post('defaultfolders', defaultfolder).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('defaultFoldersCreate', result);
                  }

                  return dataAttribute ? _defineProperty({}, dataAttribute, result.data) : result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context59.stop();
            }
          }
        }, _callee59, this);
      }));

      function defaultFoldersCreate(_x93, _x94) {
        return _defaultFoldersCreate.apply(this, arguments);
      }

      return defaultFoldersCreate;
    }()
  }, {
    key: "defaultFoldersDelete",
    value: function () {
      var _defaultFoldersDelete = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee60(defaultfolderId, dataAttribute) {
        return _regeneratorRuntime.wrap(function _callee60$(_context60) {
          while (1) {
            switch (_context60.prev = _context60.next) {
              case 0:
                return _context60.abrupt("return", this.requestService.delete("defaultfolders/".concat(defaultfolderId)).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('defaultFoldersDelete', result);
                  }

                  return dataAttribute ? _defineProperty({}, dataAttribute, result.data) : result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context60.stop();
            }
          }
        }, _callee60, this);
      }));

      function defaultFoldersDelete(_x95, _x96) {
        return _defaultFoldersDelete.apply(this, arguments);
      }

      return defaultFoldersDelete;
    }()
  }, {
    key: "defaultFoldersEdit",
    value: function () {
      var _defaultFoldersEdit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee61(defaultfolder, dataAttribute) {
        return _regeneratorRuntime.wrap(function _callee61$(_context61) {
          while (1) {
            switch (_context61.prev = _context61.next) {
              case 0:
                return _context61.abrupt("return", this.requestService.put("defaultfolders/".concat(defaultfolder.id), defaultfolder).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('defaultFoldersEdit', result);
                  }

                  return dataAttribute ? _defineProperty({}, dataAttribute, result.data) : result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context61.stop();
            }
          }
        }, _callee61, this);
      }));

      function defaultFoldersEdit(_x97, _x98) {
        return _defaultFoldersEdit.apply(this, arguments);
      }

      return defaultFoldersEdit;
    }()
  }, {
    key: "materialQuotePhotosGet",
    value: function () {
      var _materialQuotePhotosGet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee62(projectId, materialQuoteId, dataAttribute) {
        return _regeneratorRuntime.wrap(function _callee62$(_context62) {
          while (1) {
            switch (_context62.prev = _context62.next) {
              case 0:
                return _context62.abrupt("return", this.requestService.get("projects/".concat(projectId, "/materialquotes/").concat(materialQuoteId, "/photos")).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('materialQuotePhotosGet', result);
                  }

                  return dataAttribute ? _defineProperty({}, dataAttribute, result.data) : result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context62.stop();
            }
          }
        }, _callee62, this);
      }));

      function materialQuotePhotosGet(_x99, _x100, _x101) {
        return _materialQuotePhotosGet.apply(this, arguments);
      }

      return materialQuotePhotosGet;
    }()
  }, {
    key: "materialQuotePhotoGet",
    value: function () {
      var _materialQuotePhotoGet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee63(projectId, materialQuoteId, photoId, dataAttribute) {
        return _regeneratorRuntime.wrap(function _callee63$(_context63) {
          while (1) {
            switch (_context63.prev = _context63.next) {
              case 0:
                return _context63.abrupt("return", this.requestService.getImage("projects/".concat(projectId, "/materialquotes/").concat(materialQuoteId, "/photo/").concat(photoId)).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result) {
                    return _logicError('materialQuotePhotoGet', result);
                  }

                  return new Promise(function (resolve, reject) {
                    resolve(result);
                  });
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context63.stop();
            }
          }
        }, _callee63, this);
      }));

      function materialQuotePhotoGet(_x102, _x103, _x104, _x105) {
        return _materialQuotePhotoGet.apply(this, arguments);
      }

      return materialQuotePhotoGet;
    }()
  }, {
    key: "apartmentMaterialQuotePhotosSave",
    value: function () {
      var _apartmentMaterialQuotePhotosSave = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee64(projectId, payload) {
        return _regeneratorRuntime.wrap(function _callee64$(_context64) {
          while (1) {
            switch (_context64.prev = _context64.next) {
              case 0:
                return _context64.abrupt("return", this.requestService.put("projects/".concat(projectId, "/materialquotes/").concat(payload.id, "/photos"), payload, true).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('projectMaterialquotesCreate', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context64.stop();
            }
          }
        }, _callee64, this);
      }));

      function apartmentMaterialQuotePhotosSave(_x106, _x107) {
        return _apartmentMaterialQuotePhotosSave.apply(this, arguments);
      }

      return apartmentMaterialQuotePhotosSave;
    }()
  }, {
    key: "apartmentMaterialQuotePhotosDelete",
    value: function () {
      var _apartmentMaterialQuotePhotosDelete = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee65(projectId, payload) {
        return _regeneratorRuntime.wrap(function _callee65$(_context65) {
          while (1) {
            switch (_context65.prev = _context65.next) {
              case 0:
                return _context65.abrupt("return", this.requestService.delete("projects/".concat(projectId, "/materialquotes/").concat(payload.quote_id, "/photos/").concat(payload.photo_id), payload).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('projectMaterialquotesCreate', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context65.stop();
            }
          }
        }, _callee65, this);
      }));

      function apartmentMaterialQuotePhotosDelete(_x108, _x109) {
        return _apartmentMaterialQuotePhotosDelete.apply(this, arguments);
      }

      return apartmentMaterialQuotePhotosDelete;
    }()
  }, {
    key: "apartmentMaterialQuoteSave",
    value: function () {
      var _apartmentMaterialQuoteSave = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee66(projectId, payload) {
        return _regeneratorRuntime.wrap(function _callee66$(_context66) {
          while (1) {
            switch (_context66.prev = _context66.next) {
              case 0:
                return _context66.abrupt("return", this.requestService.put("projects/".concat(projectId, "/materialquotes/").concat(payload.id), payload).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('projectMaterialquotesCreate', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context66.stop();
            }
          }
        }, _callee66, this);
      }));

      function apartmentMaterialQuoteSave(_x110, _x111) {
        return _apartmentMaterialQuoteSave.apply(this, arguments);
      }

      return apartmentMaterialQuoteSave;
    }()
  }, {
    key: "apartmentMaterialQuoteRoomCardDeadlineSave",
    value: function () {
      var _apartmentMaterialQuoteRoomCardDeadlineSave = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee67(projectId, payload) {
        return _regeneratorRuntime.wrap(function _callee67$(_context67) {
          while (1) {
            switch (_context67.prev = _context67.next) {
              case 0:
                return _context67.abrupt("return", this.requestService.post("projects/".concat(projectId, "/materialquotes/").concat(payload.id, "/room-card-deadline"), payload).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('apartmentMaterialQuoteRoomCardDeadlineSave', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context67.stop();
            }
          }
        }, _callee67, this);
      }));

      function apartmentMaterialQuoteRoomCardDeadlineSave(_x112, _x113) {
        return _apartmentMaterialQuoteRoomCardDeadlineSave.apply(this, arguments);
      }

      return apartmentMaterialQuoteRoomCardDeadlineSave;
    }()
  }, {
    key: "apartmentMaterialQuotePublish",
    value: function () {
      var _apartmentMaterialQuotePublish = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee68(projectId, payload) {
        return _regeneratorRuntime.wrap(function _callee68$(_context68) {
          while (1) {
            switch (_context68.prev = _context68.next) {
              case 0:
                return _context68.abrupt("return", this.requestService.put("projects/".concat(projectId, "/materialquotes/").concat(payload.id, "/publish"), payload).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('projectMaterialquotesPublish', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context68.stop();
            }
          }
        }, _callee68, this);
      }));

      function apartmentMaterialQuotePublish(_x114, _x115) {
        return _apartmentMaterialQuotePublish.apply(this, arguments);
      }

      return apartmentMaterialQuotePublish;
    }()
  }, {
    key: "apartmentMaterialQuoteRowCommentsAdd",
    value: function () {
      var _apartmentMaterialQuoteRowCommentsAdd = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee69(quoteId, payload) {
        return _regeneratorRuntime.wrap(function _callee69$(_context69) {
          while (1) {
            switch (_context69.prev = _context69.next) {
              case 0:
                return _context69.abrupt("return", this.requestService.post("material-quote-comments/quote/".concat(quoteId, "/rows/comments"), payload).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('apartmentMaterialQuoteCommentsSave', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context69.stop();
            }
          }
        }, _callee69, this);
      }));

      function apartmentMaterialQuoteRowCommentsAdd(_x116, _x117) {
        return _apartmentMaterialQuoteRowCommentsAdd.apply(this, arguments);
      }

      return apartmentMaterialQuoteRowCommentsAdd;
    }()
  }, {
    key: "productCategoriesGet",
    value: function () {
      var _productCategoriesGet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee70() {
        var dataAttribute,
            _args70 = arguments;
        return _regeneratorRuntime.wrap(function _callee70$(_context70) {
          while (1) {
            switch (_context70.prev = _context70.next) {
              case 0:
                dataAttribute = _args70.length > 0 && _args70[0] !== undefined ? _args70[0] : false;
                return _context70.abrupt("return", this.requestService.get('productcategories?per_page=9999').then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('productCategoriesGet', result);
                  }

                  return dataAttribute ? _defineProperty({}, dataAttribute, result.data) : result.data;
                }).catch(_catcherInTheCode));

              case 2:
              case "end":
                return _context70.stop();
            }
          }
        }, _callee70, this);
      }));

      function productCategoriesGet() {
        return _productCategoriesGet.apply(this, arguments);
      }

      return productCategoriesGet;
    }()
  }, {
    key: "productCategoriesCreate",
    value: function () {
      var _productCategoriesCreate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee71(payload) {
        return _regeneratorRuntime.wrap(function _callee71$(_context71) {
          while (1) {
            switch (_context71.prev = _context71.next) {
              case 0:
                return _context71.abrupt("return", this.requestService.post('productcategories', payload).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('productCategoriesGetCreate', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context71.stop();
            }
          }
        }, _callee71, this);
      }));

      function productCategoriesCreate(_x118) {
        return _productCategoriesCreate.apply(this, arguments);
      }

      return productCategoriesCreate;
    }()
  }, {
    key: "productCategoriesDelete",
    value: function () {
      var _productCategoriesDelete = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee72(id) {
        return _regeneratorRuntime.wrap(function _callee72$(_context72) {
          while (1) {
            switch (_context72.prev = _context72.next) {
              case 0:
                return _context72.abrupt("return", this.requestService.delete("productcategories/".concat(id)).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('productCategoriesDelete', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context72.stop();
            }
          }
        }, _callee72, this);
      }));

      function productCategoriesDelete(_x119) {
        return _productCategoriesDelete.apply(this, arguments);
      }

      return productCategoriesDelete;
    }()
  }, {
    key: "productCategoriesEdit",
    value: function () {
      var _productCategoriesEdit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee73(id, payload) {
        return _regeneratorRuntime.wrap(function _callee73$(_context73) {
          while (1) {
            switch (_context73.prev = _context73.next) {
              case 0:
                return _context73.abrupt("return", this.requestService.put("productcategories/".concat(id), payload).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('productCategoriesEdit', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context73.stop();
            }
          }
        }, _callee73, this);
      }));

      function productCategoriesEdit(_x120, _x121) {
        return _productCategoriesEdit.apply(this, arguments);
      }

      return productCategoriesEdit;
    }()
  }, {
    key: "productGet",
    value: function () {
      var _productGet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee74(id) {
        return _regeneratorRuntime.wrap(function _callee74$(_context74) {
          while (1) {
            switch (_context74.prev = _context74.next) {
              case 0:
                return _context74.abrupt("return", this.requestService.get("products/".concat(id)).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('productGet', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context74.stop();
            }
          }
        }, _callee74, this);
      }));

      function productGet(_x122) {
        return _productGet.apply(this, arguments);
      }

      return productGet;
    }()
  }, {
    key: "productsGet",
    value: function () {
      var _productsGet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee75(id) {
        return _regeneratorRuntime.wrap(function _callee75$(_context75) {
          while (1) {
            switch (_context75.prev = _context75.next) {
              case 0:
                return _context75.abrupt("return", this.requestService.get("productcategories/".concat(id, "/products?per_page=9999")).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('productsGet', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context75.stop();
            }
          }
        }, _callee75, this);
      }));

      function productsGet(_x123) {
        return _productsGet.apply(this, arguments);
      }

      return productsGet;
    }()
  }, {
    key: "productsDelete",
    value: function () {
      var _productsDelete = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee76(id) {
        return _regeneratorRuntime.wrap(function _callee76$(_context76) {
          while (1) {
            switch (_context76.prev = _context76.next) {
              case 0:
                return _context76.abrupt("return", this.requestService.delete("products/".concat(id)).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('productsDelete', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context76.stop();
            }
          }
        }, _callee76, this);
      }));

      function productsDelete(_x124) {
        return _productsDelete.apply(this, arguments);
      }

      return productsDelete;
    }()
  }, {
    key: "productsEdit",
    value: function () {
      var _productsEdit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee77(id, payload) {
        return _regeneratorRuntime.wrap(function _callee77$(_context77) {
          while (1) {
            switch (_context77.prev = _context77.next) {
              case 0:
                return _context77.abrupt("return", this.requestService.put("products/".concat(id), payload, true).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('productsEdit', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context77.stop();
            }
          }
        }, _callee77, this);
      }));

      function productsEdit(_x125, _x126) {
        return _productsEdit.apply(this, arguments);
      }

      return productsEdit;
    }()
  }, {
    key: "productsCreate",
    value: function () {
      var _productsCreate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee78(payload) {
        return _regeneratorRuntime.wrap(function _callee78$(_context78) {
          while (1) {
            switch (_context78.prev = _context78.next) {
              case 0:
                return _context78.abrupt("return", this.requestService.post('products', payload).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('productsCreate', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context78.stop();
            }
          }
        }, _callee78, this);
      }));

      function productsCreate(_x127) {
        return _productsCreate.apply(this, arguments);
      }

      return productsCreate;
    }()
  }, {
    key: "contentPermissionAdd",
    value: function () {
      var _contentPermissionAdd = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee79(role, contentType, contentId) {
        var payload;
        return _regeneratorRuntime.wrap(function _callee79$(_context79) {
          while (1) {
            switch (_context79.prev = _context79.next) {
              case 0:
                payload = {
                  role_id: role.id,
                  content_type: contentType,
                  content_id: contentId
                };
                return _context79.abrupt("return", this.requestService.post('content-permissions', payload).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('contentPermissionAdd', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 2:
              case "end":
                return _context79.stop();
            }
          }
        }, _callee79, this);
      }));

      function contentPermissionAdd(_x128, _x129, _x130) {
        return _contentPermissionAdd.apply(this, arguments);
      }

      return contentPermissionAdd;
    }()
  }, {
    key: "contentPermissionRemove",
    value: function () {
      var _contentPermissionRemove = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee80(contentPermission) {
        return _regeneratorRuntime.wrap(function _callee80$(_context80) {
          while (1) {
            switch (_context80.prev = _context80.next) {
              case 0:
                return _context80.abrupt("return", this.requestService.delete("content-permissions/".concat(contentPermission.id)).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('contentPermissionRemove', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context80.stop();
            }
          }
        }, _callee80, this);
      }));

      function contentPermissionRemove(_x131) {
        return _contentPermissionRemove.apply(this, arguments);
      }

      return contentPermissionRemove;
    }()
  }, {
    key: "contentPermissionsGet",
    value: function () {
      var _contentPermissionsGet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee81(type, dataAttribute) {
        var url;
        return _regeneratorRuntime.wrap(function _callee81$(_context81) {
          while (1) {
            switch (_context81.prev = _context81.next) {
              case 0:
                url = 'content-permissions';

                if (type) {
                  url = "".concat(url, "?content_type=").concat(type);
                }

                return _context81.abrupt("return", this.requestService.get(url).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('contentPermissionsGet', result);
                  }

                  return dataAttribute ? _defineProperty({}, dataAttribute, result.data) : result.data;
                }).catch(_catcherInTheCode));

              case 3:
              case "end":
                return _context81.stop();
            }
          }
        }, _callee81, this);
      }));

      function contentPermissionsGet(_x132, _x133) {
        return _contentPermissionsGet.apply(this, arguments);
      }

      return contentPermissionsGet;
    }()
  }, {
    key: "permissionsGet",
    value: function () {
      var _permissionsGet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee82() {
        return _regeneratorRuntime.wrap(function _callee82$(_context82) {
          while (1) {
            switch (_context82.prev = _context82.next) {
              case 0:
                return _context82.abrupt("return", this.requestService.get('rolepermissions').then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('permissionsGet', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context82.stop();
            }
          }
        }, _callee82, this);
      }));

      function permissionsGet() {
        return _permissionsGet.apply(this, arguments);
      }

      return permissionsGet;
    }()
  }, {
    key: "permissionsForOwnerGet",
    value: function () {
      var _permissionsForOwnerGet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee83() {
        return _regeneratorRuntime.wrap(function _callee83$(_context83) {
          while (1) {
            switch (_context83.prev = _context83.next) {
              case 0:
                return _context83.abrupt("return", this.requestService.get('rolepermissions_owner').then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('permissionsForOwnerGet', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context83.stop();
            }
          }
        }, _callee83, this);
      }));

      function permissionsForOwnerGet() {
        return _permissionsForOwnerGet.apply(this, arguments);
      }

      return permissionsForOwnerGet;
    }()
  }, {
    key: "permissionsSave",
    value: function () {
      var _permissionsSave = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee84(role, permission) {
        var payload;
        return _regeneratorRuntime.wrap(function _callee84$(_context84) {
          while (1) {
            switch (_context84.prev = _context84.next) {
              case 0:
                payload = {
                  role: role,
                  permission: permission.name
                };
                return _context84.abrupt("return", this.requestService.post('rolepermissions', payload).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('permissionsSave', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 2:
              case "end":
                return _context84.stop();
            }
          }
        }, _callee84, this);
      }));

      function permissionsSave(_x134, _x135) {
        return _permissionsSave.apply(this, arguments);
      }

      return permissionsSave;
    }()
  }, {
    key: "permissionsDelete",
    value: function () {
      var _permissionsDelete = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee85(role, permission) {
        return _regeneratorRuntime.wrap(function _callee85$(_context85) {
          while (1) {
            switch (_context85.prev = _context85.next) {
              case 0:
                return _context85.abrupt("return", this.requestService.delete("rolepermissions/".concat(role, "/permission/").concat(permission.name)).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('permissionsDelete', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context85.stop();
            }
          }
        }, _callee85, this);
      }));

      function permissionsDelete(_x136, _x137) {
        return _permissionsDelete.apply(this, arguments);
      }

      return permissionsDelete;
    }()
  }, {
    key: "projectGet",
    value: function () {
      var _projectGet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee86(id) {
        return _regeneratorRuntime.wrap(function _callee86$(_context86) {
          while (1) {
            switch (_context86.prev = _context86.next) {
              case 0:
                return _context86.abrupt("return", this.requestService.get("projects/".concat(id)).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('getProject', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context86.stop();
            }
          }
        }, _callee86, this);
      }));

      function projectGet(_x138) {
        return _projectGet.apply(this, arguments);
      }

      return projectGet;
    }()
  }, {
    key: "projectsEdit",
    value: function () {
      var _projectsEdit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee87(id, payload) {
        return _regeneratorRuntime.wrap(function _callee87$(_context87) {
          while (1) {
            switch (_context87.prev = _context87.next) {
              case 0:
                return _context87.abrupt("return", this.requestService.put("projects/".concat(id), payload).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('projectsEdit', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context87.stop();
            }
          }
        }, _callee87, this);
      }));

      function projectsEdit(_x139, _x140) {
        return _projectsEdit.apply(this, arguments);
      }

      return projectsEdit;
    }()
  }, {
    key: "projectsDelete",
    value: function () {
      var _projectsDelete = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee88(id) {
        return _regeneratorRuntime.wrap(function _callee88$(_context88) {
          while (1) {
            switch (_context88.prev = _context88.next) {
              case 0:
                return _context88.abrupt("return", this.requestService.delete("projects/".concat(id)).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('projectsDelete', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context88.stop();
            }
          }
        }, _callee88, this);
      }));

      function projectsDelete(_x141) {
        return _projectsDelete.apply(this, arguments);
      }

      return projectsDelete;
    }()
  }, {
    key: "projectsCreate",
    value: function () {
      var _projectsCreate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee89(payload) {
        return _regeneratorRuntime.wrap(function _callee89$(_context89) {
          while (1) {
            switch (_context89.prev = _context89.next) {
              case 0:
                return _context89.abrupt("return", this.requestService.post('projects', payload).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('projectsCreate', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context89.stop();
            }
          }
        }, _callee89, this);
      }));

      function projectsCreate(_x142) {
        return _projectsCreate.apply(this, arguments);
      }

      return projectsCreate;
    }()
  }, {
    key: "projectsGet",
    value: function () {
      var _projectsGet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee90(dataAttribute) {
        var limit,
            onlyactive,
            onlyinactive,
            params,
            _args90 = arguments;
        return _regeneratorRuntime.wrap(function _callee90$(_context90) {
          while (1) {
            switch (_context90.prev = _context90.next) {
              case 0:
                limit = _args90.length > 1 && _args90[1] !== undefined ? _args90[1] : null;
                onlyactive = _args90.length > 2 && _args90[2] !== undefined ? _args90[2] : null;
                onlyinactive = _args90.length > 3 && _args90[3] !== undefined ? _args90[3] : null;
                params = 'per_page=9999';

                if (limit) {
                  params += '&limit=' + limit;
                }

                if (onlyactive == 1) {
                  params += '&onlyactive=1';
                }

                if (onlyinactive == 1) {
                  params += '&onlyinactive=1';
                }

                return _context90.abrupt("return", this.requestService.get('projects?' + params).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('projectsGet', result);
                  }

                  return dataAttribute ? _defineProperty({}, dataAttribute, result.data) : result.data;
                }).catch(_catcherInTheCode));

              case 8:
              case "end":
                return _context90.stop();
            }
          }
        }, _callee90, this);
      }));

      function projectsGet(_x143) {
        return _projectsGet.apply(this, arguments);
      }

      return projectsGet;
    }()
  }, {
    key: "projectSubtypesGet",
    value: function () {
      var _projectSubtypesGet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee91(dataAttribute) {
        return _regeneratorRuntime.wrap(function _callee91$(_context91) {
          while (1) {
            switch (_context91.prev = _context91.next) {
              case 0:
                return _context91.abrupt("return", this.requestService.get('projectSubtypes?per_page=9999').then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('projectSubtypesGet', result);
                  }

                  return dataAttribute ? _defineProperty({}, dataAttribute, result.data) : result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context91.stop();
            }
          }
        }, _callee91, this);
      }));

      function projectSubtypesGet(_x144) {
        return _projectSubtypesGet.apply(this, arguments);
      }

      return projectSubtypesGet;
    }()
  }, {
    key: "projectSubtypesCreate",
    value: function () {
      var _projectSubtypesCreate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee92(payload, dataAttribute) {
        return _regeneratorRuntime.wrap(function _callee92$(_context92) {
          while (1) {
            switch (_context92.prev = _context92.next) {
              case 0:
                return _context92.abrupt("return", this.requestService.post('projectSubtypes', payload).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('projectSubtypesCreate', result);
                  }

                  return dataAttribute ? _defineProperty({}, dataAttribute, result.data) : result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context92.stop();
            }
          }
        }, _callee92, this);
      }));

      function projectSubtypesCreate(_x145, _x146) {
        return _projectSubtypesCreate.apply(this, arguments);
      }

      return projectSubtypesCreate;
    }()
  }, {
    key: "projectSubtypesDelete",
    value: function () {
      var _projectSubtypesDelete = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee93(id, dataAttribute) {
        return _regeneratorRuntime.wrap(function _callee93$(_context93) {
          while (1) {
            switch (_context93.prev = _context93.next) {
              case 0:
                return _context93.abrupt("return", this.requestService.delete('projectSubtypes/' + id).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('projectSubtypesCreate', result);
                  }

                  return dataAttribute ? _defineProperty({}, dataAttribute, result.data) : result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context93.stop();
            }
          }
        }, _callee93, this);
      }));

      function projectSubtypesDelete(_x147, _x148) {
        return _projectSubtypesDelete.apply(this, arguments);
      }

      return projectSubtypesDelete;
    }()
  }, {
    key: "projectSubtypesSave",
    value: function () {
      var _projectSubtypesSave = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee94(payload, dataAttribute) {
        return _regeneratorRuntime.wrap(function _callee94$(_context94) {
          while (1) {
            switch (_context94.prev = _context94.next) {
              case 0:
                return _context94.abrupt("return", this.requestService.put('projectSubtypes/' + payload.id, payload).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('projectSubtypesCreate', result);
                  }

                  return dataAttribute ? _defineProperty({}, dataAttribute, result.data) : result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context94.stop();
            }
          }
        }, _callee94, this);
      }));

      function projectSubtypesSave(_x149, _x150) {
        return _projectSubtypesSave.apply(this, arguments);
      }

      return projectSubtypesSave;
    }()
  }, {
    key: "projectContactsGet",
    value: function () {
      var _projectContactsGet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee95(id, dataAttribute) {
        return _regeneratorRuntime.wrap(function _callee95$(_context95) {
          while (1) {
            switch (_context95.prev = _context95.next) {
              case 0:
                return _context95.abrupt("return", this.requestService.get("projects/".concat(id, "/contacts?per_page=9999")).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('projectContactsGet', result);
                  }

                  return dataAttribute ? _defineProperty({}, dataAttribute, result.data) : result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context95.stop();
            }
          }
        }, _callee95, this);
      }));

      function projectContactsGet(_x151, _x152) {
        return _projectContactsGet.apply(this, arguments);
      }

      return projectContactsGet;
    }()
  }, {
    key: "projectContactsCreate",
    value: function () {
      var _projectContactsCreate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee96(id, payload) {
        return _regeneratorRuntime.wrap(function _callee96$(_context96) {
          while (1) {
            switch (_context96.prev = _context96.next) {
              case 0:
                return _context96.abrupt("return", this.requestService.post("projects/".concat(id, "/contacts"), payload).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('projectsContactsCreate', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context96.stop();
            }
          }
        }, _callee96, this);
      }));

      function projectContactsCreate(_x153, _x154) {
        return _projectContactsCreate.apply(this, arguments);
      }

      return projectContactsCreate;
    }()
  }, {
    key: "projectContactsDelete",
    value: function () {
      var _projectContactsDelete = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee97(projectId, contactId) {
        return _regeneratorRuntime.wrap(function _callee97$(_context97) {
          while (1) {
            switch (_context97.prev = _context97.next) {
              case 0:
                return _context97.abrupt("return", this.requestService.delete("projects/".concat(projectId, "/contacts/").concat(contactId)).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('productContactsDelete', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context97.stop();
            }
          }
        }, _callee97, this);
      }));

      function projectContactsDelete(_x155, _x156) {
        return _projectContactsDelete.apply(this, arguments);
      }

      return projectContactsDelete;
    }()
  }, {
    key: "projectContactsEdit",
    value: function () {
      var _projectContactsEdit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee98(projectId, contactId, payload) {
        return _regeneratorRuntime.wrap(function _callee98$(_context98) {
          while (1) {
            switch (_context98.prev = _context98.next) {
              case 0:
                return _context98.abrupt("return", this.requestService.put("projects/".concat(projectId, "/contacts/").concat(contactId), payload).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('productContactsEdit', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context98.stop();
            }
          }
        }, _callee98, this);
      }));

      function projectContactsEdit(_x157, _x158, _x159) {
        return _projectContactsEdit.apply(this, arguments);
      }

      return projectContactsEdit;
    }()
  }, {
    key: "projectNotificationsGet",
    value: function () {
      var _projectNotificationsGet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee99(id, dataAttribute) {
        return _regeneratorRuntime.wrap(function _callee99$(_context99) {
          while (1) {
            switch (_context99.prev = _context99.next) {
              case 0:
                return _context99.abrupt("return", this.requestService.get("projects/".concat(id, "/notifications?per_page=9999")).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('projectNotificationsGet', result);
                  }

                  return dataAttribute ? _defineProperty({}, dataAttribute, result.data) : result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context99.stop();
            }
          }
        }, _callee99, this);
      }));

      function projectNotificationsGet(_x160, _x161) {
        return _projectNotificationsGet.apply(this, arguments);
      }

      return projectNotificationsGet;
    }()
  }, {
    key: "projectNotificationsCreate",
    value: function () {
      var _projectNotificationsCreate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee100(id, payload) {
        return _regeneratorRuntime.wrap(function _callee100$(_context100) {
          while (1) {
            switch (_context100.prev = _context100.next) {
              case 0:
                return _context100.abrupt("return", this.requestService.post("projects/".concat(id, "/notifications"), payload).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('projectNotificationsCreate', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context100.stop();
            }
          }
        }, _callee100, this);
      }));

      function projectNotificationsCreate(_x162, _x163) {
        return _projectNotificationsCreate.apply(this, arguments);
      }

      return projectNotificationsCreate;
    }()
  }, {
    key: "projectNotificationsDelete",
    value: function () {
      var _projectNotificationsDelete = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee101(projectId, notificationId) {
        return _regeneratorRuntime.wrap(function _callee101$(_context101) {
          while (1) {
            switch (_context101.prev = _context101.next) {
              case 0:
                return _context101.abrupt("return", this.requestService.delete("projects/".concat(projectId, "/notifications/").concat(notificationId)).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('projectNotificationsDelete', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context101.stop();
            }
          }
        }, _callee101, this);
      }));

      function projectNotificationsDelete(_x164, _x165) {
        return _projectNotificationsDelete.apply(this, arguments);
      }

      return projectNotificationsDelete;
    }()
  }, {
    key: "materialFormDeadlineGet",
    value: function () {
      var _materialFormDeadlineGet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee102(id) {
        return _regeneratorRuntime.wrap(function _callee102$(_context102) {
          while (1) {
            switch (_context102.prev = _context102.next) {
              case 0:
                return _context102.abrupt("return", this.requestService.get("materialFormDeadlines").then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  return result;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context102.stop();
            }
          }
        }, _callee102, this);
      }));

      function materialFormDeadlineGet(_x166) {
        return _materialFormDeadlineGet.apply(this, arguments);
      }

      return materialFormDeadlineGet;
    }()
  }, {
    key: "materialFormDeadlineCreate",
    value: function () {
      var _materialFormDeadlineCreate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee103(payload) {
        return _regeneratorRuntime.wrap(function _callee103$(_context103) {
          while (1) {
            switch (_context103.prev = _context103.next) {
              case 0:
                return _context103.abrupt("return", this.requestService.post("materialFormDeadlines", payload).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  return result;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context103.stop();
            }
          }
        }, _callee103, this);
      }));

      function materialFormDeadlineCreate(_x167) {
        return _materialFormDeadlineCreate.apply(this, arguments);
      }

      return materialFormDeadlineCreate;
    }()
  }, {
    key: "materialFormDeadlineDelete",
    value: function () {
      var _materialFormDeadlineDelete = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee104(deadlineId) {
        return _regeneratorRuntime.wrap(function _callee104$(_context104) {
          while (1) {
            switch (_context104.prev = _context104.next) {
              case 0:
                return _context104.abrupt("return", this.requestService.delete("materialFormDeadlines/".concat(deadlineId)).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  return result;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context104.stop();
            }
          }
        }, _callee104, this);
      }));

      function materialFormDeadlineDelete(_x168) {
        return _materialFormDeadlineDelete.apply(this, arguments);
      }

      return materialFormDeadlineDelete;
    }()
  }, {
    key: "materialFormDeadlineEdit",
    value: function () {
      var _materialFormDeadlineEdit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee105(deadlineId, payload) {
        return _regeneratorRuntime.wrap(function _callee105$(_context105) {
          while (1) {
            switch (_context105.prev = _context105.next) {
              case 0:
                return _context105.abrupt("return", this.requestService.put("materialFormDeadlines/".concat(deadlineId), payload).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  return result;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context105.stop();
            }
          }
        }, _callee105, this);
      }));

      function materialFormDeadlineEdit(_x169, _x170) {
        return _materialFormDeadlineEdit.apply(this, arguments);
      }

      return materialFormDeadlineEdit;
    }()
  }, {
    key: "quoteDeadlineCreate",
    value: function () {
      var _quoteDeadlineCreate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee106(payload) {
        return _regeneratorRuntime.wrap(function _callee106$(_context106) {
          while (1) {
            switch (_context106.prev = _context106.next) {
              case 0:
                return _context106.abrupt("return", this.requestService.post("quoteDeadlines", payload).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  return result;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context106.stop();
            }
          }
        }, _callee106, this);
      }));

      function quoteDeadlineCreate(_x171) {
        return _quoteDeadlineCreate.apply(this, arguments);
      }

      return quoteDeadlineCreate;
    }()
  }, {
    key: "quoteDeadlineDelete",
    value: function () {
      var _quoteDeadlineDelete = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee107(deadlineId) {
        return _regeneratorRuntime.wrap(function _callee107$(_context107) {
          while (1) {
            switch (_context107.prev = _context107.next) {
              case 0:
                return _context107.abrupt("return", this.requestService.delete("quoteDeadlines/".concat(deadlineId)).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  return result;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context107.stop();
            }
          }
        }, _callee107, this);
      }));

      function quoteDeadlineDelete(_x172) {
        return _quoteDeadlineDelete.apply(this, arguments);
      }

      return quoteDeadlineDelete;
    }()
  }, {
    key: "quoteDeadlineEdit",
    value: function () {
      var _quoteDeadlineEdit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee108(deadlineId, payload) {
        return _regeneratorRuntime.wrap(function _callee108$(_context108) {
          while (1) {
            switch (_context108.prev = _context108.next) {
              case 0:
                return _context108.abrupt("return", this.requestService.put("quoteDeadlines/".concat(deadlineId), payload).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  return result;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context108.stop();
            }
          }
        }, _callee108, this);
      }));

      function quoteDeadlineEdit(_x173, _x174) {
        return _quoteDeadlineEdit.apply(this, arguments);
      }

      return quoteDeadlineEdit;
    }()
  }, {
    key: "projectCondominiumsGet",
    value: function () {
      var _projectCondominiumsGet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee109(id, dataAttribute) {
        return _regeneratorRuntime.wrap(function _callee109$(_context109) {
          while (1) {
            switch (_context109.prev = _context109.next) {
              case 0:
                return _context109.abrupt("return", this.requestService.get("projects/".concat(id, "/contacts?per_page=9999")).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('projectCondominiumsGet', result);
                  }

                  return dataAttribute ? _defineProperty({}, dataAttribute, result.data) : result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context109.stop();
            }
          }
        }, _callee109, this);
      }));

      function projectCondominiumsGet(_x175, _x176) {
        return _projectCondominiumsGet.apply(this, arguments);
      }

      return projectCondominiumsGet;
    }()
  }, {
    key: "projectFoldersGet",
    value: function () {
      var _projectFoldersGet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee110(id, dataAttribute) {
        return _regeneratorRuntime.wrap(function _callee110$(_context110) {
          while (1) {
            switch (_context110.prev = _context110.next) {
              case 0:
                return _context110.abrupt("return", this.requestService.get("projects/".concat(id, "/folders?per_page=9999")).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('projectFoldersGet', result);
                  }

                  return dataAttribute ? _defineProperty({}, dataAttribute, result.data) : result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context110.stop();
            }
          }
        }, _callee110, this);
      }));

      function projectFoldersGet(_x177, _x178) {
        return _projectFoldersGet.apply(this, arguments);
      }

      return projectFoldersGet;
    }()
  }, {
    key: "condominiumFoldersGet",
    value: function () {
      var _condominiumFoldersGet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee111(projectId, dataAttribute) {
        return _regeneratorRuntime.wrap(function _callee111$(_context111) {
          while (1) {
            switch (_context111.prev = _context111.next) {
              case 0:
                return _context111.abrupt("return", this.requestService.get("condominium/project/".concat(projectId, "/folders")).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('condominiumFoldersGet', result);
                  }

                  return dataAttribute ? _defineProperty({}, dataAttribute, result.data) : result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context111.stop();
            }
          }
        }, _callee111, this);
      }));

      function condominiumFoldersGet(_x179, _x180) {
        return _condominiumFoldersGet.apply(this, arguments);
      }

      return condominiumFoldersGet;
    }()
  }, {
    key: "projectFolderCreate",
    value: function () {
      var _projectFolderCreate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee112(project, payload) {
        return _regeneratorRuntime.wrap(function _callee112$(_context112) {
          while (1) {
            switch (_context112.prev = _context112.next) {
              case 0:
                return _context112.abrupt("return", this.requestService.post("projects/".concat(project.id, "/folders"), payload).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('projectFolderCreate', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context112.stop();
            }
          }
        }, _callee112, this);
      }));

      function projectFolderCreate(_x181, _x182) {
        return _projectFolderCreate.apply(this, arguments);
      }

      return projectFolderCreate;
    }()
  }, {
    key: "projectFolderDelete",
    value: function () {
      var _projectFolderDelete = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee113(folder) {
        return _regeneratorRuntime.wrap(function _callee113$(_context113) {
          while (1) {
            switch (_context113.prev = _context113.next) {
              case 0:
                return _context113.abrupt("return", this.requestService.delete("folders/".concat(folder.id)).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('projectFolderDelete', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context113.stop();
            }
          }
        }, _callee113, this);
      }));

      function projectFolderDelete(_x183) {
        return _projectFolderDelete.apply(this, arguments);
      }

      return projectFolderDelete;
    }()
  }, {
    key: "projectFolderEdit",
    value: function () {
      var _projectFolderEdit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee114(folder, payload) {
        return _regeneratorRuntime.wrap(function _callee114$(_context114) {
          while (1) {
            switch (_context114.prev = _context114.next) {
              case 0:
                return _context114.abrupt("return", this.requestService.put("folders/".concat(folder.id), payload).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('projectFolderEdit', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context114.stop();
            }
          }
        }, _callee114, this);
      }));

      function projectFolderEdit(_x184, _x185) {
        return _projectFolderEdit.apply(this, arguments);
      }

      return projectFolderEdit;
    }()
  }, {
    key: "condominiumProjectDocumentsGet",
    value: function () {
      var _condominiumProjectDocumentsGet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee115(id, fields, converterFunc, dataAttribute) {
        return _regeneratorRuntime.wrap(function _callee115$(_context115) {
          while (1) {
            switch (_context115.prev = _context115.next) {
              case 0:
                return _context115.abrupt("return", this.requestService.get("projects/".concat(id, "/condominiumdocuments?per_page=9999")).then(function (result) {
                  if (result.error) {
                    return {
                      error: result.error
                    };
                  }

                  var results = result.data.map(function (item, index) {
                    return converterFunc(item, id, fields, index);
                  });
                  return dataAttribute ? _defineProperty({}, dataAttribute, results) : results;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context115.stop();
            }
          }
        }, _callee115, this);
      }));

      function condominiumProjectDocumentsGet(_x186, _x187, _x188, _x189) {
        return _condominiumProjectDocumentsGet.apply(this, arguments);
      }

      return condominiumProjectDocumentsGet;
    }()
  }, {
    key: "projectSchedulesGet",
    value: function () {
      var _projectSchedulesGet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee116(id, dataAttribute) {
        return _regeneratorRuntime.wrap(function _callee116$(_context116) {
          while (1) {
            switch (_context116.prev = _context116.next) {
              case 0:
                return _context116.abrupt("return", this.requestService.get("projects/".concat(id, "/schedules?per_page=9999")).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('projectSchedulesGet', result);
                  }

                  return dataAttribute ? _defineProperty({}, dataAttribute, result.data) : result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context116.stop();
            }
          }
        }, _callee116, this);
      }));

      function projectSchedulesGet(_x190, _x191) {
        return _projectSchedulesGet.apply(this, arguments);
      }

      return projectSchedulesGet;
    }()
  }, {
    key: "projectSchedulesCreate",
    value: function () {
      var _projectSchedulesCreate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee117(projectId, payload) {
        return _regeneratorRuntime.wrap(function _callee117$(_context117) {
          while (1) {
            switch (_context117.prev = _context117.next) {
              case 0:
                return _context117.abrupt("return", this.requestService.post("projects/".concat(projectId, "/schedules"), payload).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('projectSchedulesCreate', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context117.stop();
            }
          }
        }, _callee117, this);
      }));

      function projectSchedulesCreate(_x192, _x193) {
        return _projectSchedulesCreate.apply(this, arguments);
      }

      return projectSchedulesCreate;
    }()
  }, {
    key: "projectSchedulesDelete",
    value: function () {
      var _projectSchedulesDelete = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee118(projectId, scheduleId) {
        return _regeneratorRuntime.wrap(function _callee118$(_context118) {
          while (1) {
            switch (_context118.prev = _context118.next) {
              case 0:
                return _context118.abrupt("return", this.requestService.delete("projects/".concat(projectId, "/schedules/").concat(scheduleId)).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('productSchedulesDelete', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context118.stop();
            }
          }
        }, _callee118, this);
      }));

      function projectSchedulesDelete(_x194, _x195) {
        return _projectSchedulesDelete.apply(this, arguments);
      }

      return projectSchedulesDelete;
    }()
  }, {
    key: "projectSchedulesEdit",
    value: function () {
      var _projectSchedulesEdit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee119(projectId, scheduleId, payload) {
        return _regeneratorRuntime.wrap(function _callee119$(_context119) {
          while (1) {
            switch (_context119.prev = _context119.next) {
              case 0:
                return _context119.abrupt("return", this.requestService.put("projects/".concat(projectId, "/schedules/").concat(scheduleId), payload).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('productSchedulesEdit', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context119.stop();
            }
          }
        }, _callee119, this);
      }));

      function projectSchedulesEdit(_x196, _x197, _x198) {
        return _projectSchedulesEdit.apply(this, arguments);
      }

      return projectSchedulesEdit;
    }()
  }, {
    key: "materialFormsGet",
    value: function () {
      var _materialFormsGet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee120() {
        return _regeneratorRuntime.wrap(function _callee120$(_context120) {
          while (1) {
            switch (_context120.prev = _context120.next) {
              case 0:
                return _context120.abrupt("return", this.requestService.get("materialforms?per_page=9999").then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('MaterialFormsGet', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context120.stop();
            }
          }
        }, _callee120, this);
      }));

      function materialFormsGet() {
        return _materialFormsGet.apply(this, arguments);
      }

      return materialFormsGet;
    }()
  }, {
    key: "projectMaterialFormsGet",
    value: function () {
      var _projectMaterialFormsGet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee121(id, dataAttribute) {
        return _regeneratorRuntime.wrap(function _callee121$(_context121) {
          while (1) {
            switch (_context121.prev = _context121.next) {
              case 0:
                return _context121.abrupt("return", this.requestService.get("projects/".concat(id, "/materialforms?per_page=9999")).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('projectMaterialFormsGet', result);
                  }

                  return dataAttribute ? _defineProperty({}, dataAttribute, result.data) : result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context121.stop();
            }
          }
        }, _callee121, this);
      }));

      function projectMaterialFormsGet(_x199, _x200) {
        return _projectMaterialFormsGet.apply(this, arguments);
      }

      return projectMaterialFormsGet;
    }()
  }, {
    key: "projectMaterialFormGet",
    value: function () {
      var _projectMaterialFormGet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee122(projectid, materialformid, dataAttribute) {
        return _regeneratorRuntime.wrap(function _callee122$(_context122) {
          while (1) {
            switch (_context122.prev = _context122.next) {
              case 0:
                return _context122.abrupt("return", this.requestService.get("projects/".concat(projectid, "/materialforms/").concat(materialformid)).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('projectMaterialFormsGet', result);
                  }

                  return dataAttribute ? _defineProperty({}, dataAttribute, result.data) : result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context122.stop();
            }
          }
        }, _callee122, this);
      }));

      function projectMaterialFormGet(_x201, _x202, _x203) {
        return _projectMaterialFormGet.apply(this, arguments);
      }

      return projectMaterialFormGet;
    }()
  }, {
    key: "projectMaterialFormsForThisApartmentGet",
    value: function () {
      var _projectMaterialFormsForThisApartmentGet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee123(id, apartmentId, dataAttribute) {
        return _regeneratorRuntime.wrap(function _callee123$(_context123) {
          while (1) {
            switch (_context123.prev = _context123.next) {
              case 0:
                return _context123.abrupt("return", this.requestService.get("projects/".concat(id, "/materialforms/apartment/").concat(apartmentId)).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('projectMaterialFormsGet', result);
                  }

                  return dataAttribute ? _defineProperty({}, dataAttribute, result.data) : result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context123.stop();
            }
          }
        }, _callee123, this);
      }));

      function projectMaterialFormsForThisApartmentGet(_x204, _x205, _x206) {
        return _projectMaterialFormsForThisApartmentGet.apply(this, arguments);
      }

      return projectMaterialFormsForThisApartmentGet;
    }()
  }, {
    key: "projectMaterialFormsCreate",
    value: function () {
      var _projectMaterialFormsCreate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee124(projectId, payload) {
        return _regeneratorRuntime.wrap(function _callee124$(_context124) {
          while (1) {
            switch (_context124.prev = _context124.next) {
              case 0:
                return _context124.abrupt("return", this.requestService.post("projects/".concat(projectId, "/materialforms"), payload).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('projectMaterialFormsCreate', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context124.stop();
            }
          }
        }, _callee124, this);
      }));

      function projectMaterialFormsCreate(_x207, _x208) {
        return _projectMaterialFormsCreate.apply(this, arguments);
      }

      return projectMaterialFormsCreate;
    }()
  }, {
    key: "projectMaterialFormsDuplicate",
    value: function () {
      var _projectMaterialFormsDuplicate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee125(projectid, materialformid, dataAttribute) {
        return _regeneratorRuntime.wrap(function _callee125$(_context125) {
          while (1) {
            switch (_context125.prev = _context125.next) {
              case 0:
                return _context125.abrupt("return", this.requestService.get("projects/".concat(projectid, "/materialforms/").concat(materialformid, "/duplicate")).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('projectMaterialFormsDuplicate', result);
                  }

                  return dataAttribute ? _defineProperty({}, dataAttribute, result.data) : result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context125.stop();
            }
          }
        }, _callee125, this);
      }));

      function projectMaterialFormsDuplicate(_x209, _x210, _x211) {
        return _projectMaterialFormsDuplicate.apply(this, arguments);
      }

      return projectMaterialFormsDuplicate;
    }()
  }, {
    key: "projectMaterialFormsUpdate",
    value: function () {
      var _projectMaterialFormsUpdate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee126(projectId, materialformId, payload) {
        return _regeneratorRuntime.wrap(function _callee126$(_context126) {
          while (1) {
            switch (_context126.prev = _context126.next) {
              case 0:
                return _context126.abrupt("return", this.requestService.put("projects/".concat(projectId, "/materialforms/").concat(materialformId), payload).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('projectMaterialFormsUpdate', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context126.stop();
            }
          }
        }, _callee126, this);
      }));

      function projectMaterialFormsUpdate(_x212, _x213, _x214) {
        return _projectMaterialFormsUpdate.apply(this, arguments);
      }

      return projectMaterialFormsUpdate;
    }()
  }, {
    key: "projectMaterialFormsDelete",
    value: function () {
      var _projectMaterialFormsDelete = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee127(projectId, id) {
        return _regeneratorRuntime.wrap(function _callee127$(_context127) {
          while (1) {
            switch (_context127.prev = _context127.next) {
              case 0:
                return _context127.abrupt("return", this.requestService.delete("projects/".concat(projectId, "/materialforms/").concat(id)).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('projectMaterialFormsDelete', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context127.stop();
            }
          }
        }, _callee127, this);
      }));

      function projectMaterialFormsDelete(_x215, _x216) {
        return _projectMaterialFormsDelete.apply(this, arguments);
      }

      return projectMaterialFormsDelete;
    }()
  }, {
    key: "projectMaterialFormsGroupsCreate",
    value: function () {
      var _projectMaterialFormsGroupsCreate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee128(materialformId, payload) {
        return _regeneratorRuntime.wrap(function _callee128$(_context128) {
          while (1) {
            switch (_context128.prev = _context128.next) {
              case 0:
                return _context128.abrupt("return", this.requestService.post("materialforms/".concat(materialformId, "/groups"), payload).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('projectMaterialFormsGroupsCreate', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context128.stop();
            }
          }
        }, _callee128, this);
      }));

      function projectMaterialFormsGroupsCreate(_x217, _x218) {
        return _projectMaterialFormsGroupsCreate.apply(this, arguments);
      }

      return projectMaterialFormsGroupsCreate;
    }()
  }, {
    key: "projectMaterialFormsGroupsUpdate",
    value: function () {
      var _projectMaterialFormsGroupsUpdate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee129(materialformId, payload) {
        return _regeneratorRuntime.wrap(function _callee129$(_context129) {
          while (1) {
            switch (_context129.prev = _context129.next) {
              case 0:
                return _context129.abrupt("return", this.requestService.put("materialforms/".concat(materialformId, "/groups/").concat(payload.id), payload).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('projectMaterialFormsGroupsUpdate', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context129.stop();
            }
          }
        }, _callee129, this);
      }));

      function projectMaterialFormsGroupsUpdate(_x219, _x220) {
        return _projectMaterialFormsGroupsUpdate.apply(this, arguments);
      }

      return projectMaterialFormsGroupsUpdate;
    }()
  }, {
    key: "projectMaterialFormsGroupsDelete",
    value: function () {
      var _projectMaterialFormsGroupsDelete = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee130(materialformId, groupId) {
        return _regeneratorRuntime.wrap(function _callee130$(_context130) {
          while (1) {
            switch (_context130.prev = _context130.next) {
              case 0:
                return _context130.abrupt("return", this.requestService.delete("materialforms/".concat(materialformId, "/groups/").concat(groupId)).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('projectMaterialFormsGroupsDelete', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context130.stop();
            }
          }
        }, _callee130, this);
      }));

      function projectMaterialFormsGroupsDelete(_x221, _x222) {
        return _projectMaterialFormsGroupsDelete.apply(this, arguments);
      }

      return projectMaterialFormsGroupsDelete;
    }()
  }, {
    key: "projectMaterialFormsSelectCreate",
    value: function () {
      var _projectMaterialFormsSelectCreate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee131(groupId, payload) {
        return _regeneratorRuntime.wrap(function _callee131$(_context131) {
          while (1) {
            switch (_context131.prev = _context131.next) {
              case 0:
                return _context131.abrupt("return", this.requestService.post("materialformgroups/".concat(groupId, "/selects"), payload).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('projectMaterialFormsSelectCreate', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context131.stop();
            }
          }
        }, _callee131, this);
      }));

      function projectMaterialFormsSelectCreate(_x223, _x224) {
        return _projectMaterialFormsSelectCreate.apply(this, arguments);
      }

      return projectMaterialFormsSelectCreate;
    }()
  }, {
    key: "projectMaterialFormsSelectUpdate",
    value: function () {
      var _projectMaterialFormsSelectUpdate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee132(groupId, payload) {
        return _regeneratorRuntime.wrap(function _callee132$(_context132) {
          while (1) {
            switch (_context132.prev = _context132.next) {
              case 0:
                return _context132.abrupt("return", this.requestService.put("materialformgroups/".concat(groupId, "/selects/").concat(payload.id), payload).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('projectMaterialFormsSelectUpdate', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context132.stop();
            }
          }
        }, _callee132, this);
      }));

      function projectMaterialFormsSelectUpdate(_x225, _x226) {
        return _projectMaterialFormsSelectUpdate.apply(this, arguments);
      }

      return projectMaterialFormsSelectUpdate;
    }()
  }, {
    key: "projectMaterialFormsSelectDelete",
    value: function () {
      var _projectMaterialFormsSelectDelete = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee133(groupId, selectId) {
        return _regeneratorRuntime.wrap(function _callee133$(_context133) {
          while (1) {
            switch (_context133.prev = _context133.next) {
              case 0:
                return _context133.abrupt("return", this.requestService.delete("materialformgroups/".concat(groupId, "/selects/").concat(selectId)).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('projectMaterialFormsSelectDelete', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context133.stop();
            }
          }
        }, _callee133, this);
      }));

      function projectMaterialFormsSelectDelete(_x227, _x228) {
        return _projectMaterialFormsSelectDelete.apply(this, arguments);
      }

      return projectMaterialFormsSelectDelete;
    }()
  }, {
    key: "projectMaterialFormsOptionCreate",
    value: function () {
      var _projectMaterialFormsOptionCreate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee134(selectId, payload) {
        return _regeneratorRuntime.wrap(function _callee134$(_context134) {
          while (1) {
            switch (_context134.prev = _context134.next) {
              case 0:
                return _context134.abrupt("return", this.requestService.post("materialformselects/".concat(selectId, "/options"), payload).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('projectMaterialFormsOptionCreate', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context134.stop();
            }
          }
        }, _callee134, this);
      }));

      function projectMaterialFormsOptionCreate(_x229, _x230) {
        return _projectMaterialFormsOptionCreate.apply(this, arguments);
      }

      return projectMaterialFormsOptionCreate;
    }()
  }, {
    key: "projectMaterialFormsOptionUpdate",
    value: function () {
      var _projectMaterialFormsOptionUpdate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee135(selectId, payload) {
        return _regeneratorRuntime.wrap(function _callee135$(_context135) {
          while (1) {
            switch (_context135.prev = _context135.next) {
              case 0:
                return _context135.abrupt("return", this.requestService.put("materialformselects/".concat(selectId, "/options/").concat(payload.id), payload).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('projectMaterialFormsOptionUpdate', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context135.stop();
            }
          }
        }, _callee135, this);
      }));

      function projectMaterialFormsOptionUpdate(_x231, _x232) {
        return _projectMaterialFormsOptionUpdate.apply(this, arguments);
      }

      return projectMaterialFormsOptionUpdate;
    }()
  }, {
    key: "projectMaterialFormsOptionsDelete",
    value: function () {
      var _projectMaterialFormsOptionsDelete = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee136(selectId, optionId) {
        return _regeneratorRuntime.wrap(function _callee136$(_context136) {
          while (1) {
            switch (_context136.prev = _context136.next) {
              case 0:
                return _context136.abrupt("return", this.requestService.delete("materialformselects/".concat(selectId, "/options/").concat(optionId)).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('projectMaterialFormsOptionUpdate', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context136.stop();
            }
          }
        }, _callee136, this);
      }));

      function projectMaterialFormsOptionsDelete(_x233, _x234) {
        return _projectMaterialFormsOptionsDelete.apply(this, arguments);
      }

      return projectMaterialFormsOptionsDelete;
    }()
  }, {
    key: "projectMaterialquotesGet",
    value: function () {
      var _projectMaterialquotesGet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee137(projectId) {
        return _regeneratorRuntime.wrap(function _callee137$(_context137) {
          while (1) {
            switch (_context137.prev = _context137.next) {
              case 0:
                return _context137.abrupt("return", this.requestService.get("projects/".concat(projectId, "/materialquotes")).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('projectMaterialquotesGet', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context137.stop();
            }
          }
        }, _callee137, this);
      }));

      function projectMaterialquotesGet(_x235) {
        return _projectMaterialquotesGet.apply(this, arguments);
      }

      return projectMaterialquotesGet;
    }()
  }, {
    key: "projectMaterialquotesCreate",
    value: function () {
      var _projectMaterialquotesCreate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee138(projectId, payload) {
        return _regeneratorRuntime.wrap(function _callee138$(_context138) {
          while (1) {
            switch (_context138.prev = _context138.next) {
              case 0:
                return _context138.abrupt("return", this.requestService.post("projects/".concat(projectId, "/materialquotes"), payload).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('projectMaterialquotesCreate', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context138.stop();
            }
          }
        }, _callee138, this);
      }));

      function projectMaterialquotesCreate(_x236, _x237) {
        return _projectMaterialquotesCreate.apply(this, arguments);
      }

      return projectMaterialquotesCreate;
    }()
  }, {
    key: "projectMaterialQuotesGet",
    value: function () {
      var _projectMaterialQuotesGet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee139(id, dataAttribute) {
        return _regeneratorRuntime.wrap(function _callee139$(_context139) {
          while (1) {
            switch (_context139.prev = _context139.next) {
              case 0:
                return _context139.abrupt("return", this.requestService.get("projects/".concat(id, "/materialquotes?per_page=9999")).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('projectMaterialQuotesGet', result);
                  }

                  return dataAttribute ? _defineProperty({}, dataAttribute, result.data) : result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context139.stop();
            }
          }
        }, _callee139, this);
      }));

      function projectMaterialQuotesGet(_x238, _x239) {
        return _projectMaterialQuotesGet.apply(this, arguments);
      }

      return projectMaterialQuotesGet;
    }()
  }, {
    key: "projectDocumentsGet",
    value: function () {
      var _projectDocumentsGet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee140(id, fields, converterFunc, dataAttribute) {
        return _regeneratorRuntime.wrap(function _callee140$(_context140) {
          while (1) {
            switch (_context140.prev = _context140.next) {
              case 0:
                return _context140.abrupt("return", this.requestService.get("projects/".concat(id, "/documents?per_page=9999")).then(function (result) {
                  if (result.error) {
                    return {
                      error: result.error
                    };
                  }

                  var results = result.data.map(function (item, index) {
                    return converterFunc(item, id, fields, index);
                  });
                  return dataAttribute ? _defineProperty({}, dataAttribute, results) : results;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context140.stop();
            }
          }
        }, _callee140, this);
      }));

      function projectDocumentsGet(_x240, _x241, _x242, _x243) {
        return _projectDocumentsGet.apply(this, arguments);
      }

      return projectDocumentsGet;
    }()
  }, {
    key: "allDocumentsFromPicturesFolderGet",
    value: function () {
      var _allDocumentsFromPicturesFolderGet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee141(projectId, dataAttribute) {
        return _regeneratorRuntime.wrap(function _callee141$(_context141) {
          while (1) {
            switch (_context141.prev = _context141.next) {
              case 0:
                return _context141.abrupt("return", this.requestService.get("projects/".concat(projectId, "/pictures")).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    _logicError('allDocumentsFromPicturesFolderGet', result);
                  }

                  return dataAttribute ? _defineProperty({}, dataAttribute, result.data) : result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context141.stop();
            }
          }
        }, _callee141, this);
      }));

      function allDocumentsFromPicturesFolderGet(_x244, _x245) {
        return _allDocumentsFromPicturesFolderGet.apply(this, arguments);
      }

      return allDocumentsFromPicturesFolderGet;
    }()
  }, {
    key: "projectCondominiumSet",
    value: function () {
      var _projectCondominiumSet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee142(projectId, condominiumId) {
        var payload;
        return _regeneratorRuntime.wrap(function _callee142$(_context142) {
          while (1) {
            switch (_context142.prev = _context142.next) {
              case 0:
                payload = {
                  condominium_id: condominiumId,
                  project_id: projectId
                };
                return _context142.abrupt("return", this.requestService.post('condominiumprojects', payload).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('projectCondominiumSet', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 2:
              case "end":
                return _context142.stop();
            }
          }
        }, _callee142, this);
      }));

      function projectCondominiumSet(_x246, _x247) {
        return _projectCondominiumSet.apply(this, arguments);
      }

      return projectCondominiumSet;
    }()
  }, {
    key: "materialSelectionDeadlinesGet",
    value: function () {
      var _materialSelectionDeadlinesGet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee143(id, dataAttribute) {
        return _regeneratorRuntime.wrap(function _callee143$(_context143) {
          while (1) {
            switch (_context143.prev = _context143.next) {
              case 0:
                return _context143.abrupt("return", this.requestService.get("projects/".concat(id, "/materialdeadlines?per_page=9999")).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('materialSelectionDeadlinesGet', result);
                  }

                  return dataAttribute ? _defineProperty({}, dataAttribute, result.data) : result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context143.stop();
            }
          }
        }, _callee143, this);
      }));

      function materialSelectionDeadlinesGet(_x248, _x249) {
        return _materialSelectionDeadlinesGet.apply(this, arguments);
      }

      return materialSelectionDeadlinesGet;
    }()
  }, {
    key: "materialFormsDeadlineGet",
    value: function () {
      var _materialFormsDeadlineGet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee144(id, dataAttribute) {
        return _regeneratorRuntime.wrap(function _callee144$(_context144) {
          while (1) {
            switch (_context144.prev = _context144.next) {
              case 0:
                return _context144.abrupt("return", this.requestService.get("project/".concat(id, "/materialformdeadlines")).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('materialFormDeadlineGet', result);
                  }

                  return dataAttribute ? _defineProperty({}, dataAttribute, result.data) : result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context144.stop();
            }
          }
        }, _callee144, this);
      }));

      function materialFormsDeadlineGet(_x250, _x251) {
        return _materialFormsDeadlineGet.apply(this, arguments);
      }

      return materialFormsDeadlineGet;
    }()
  }, {
    key: "materialSelectionDeadlinesCreate",
    value: function () {
      var _materialSelectionDeadlinesCreate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee145(id, payload, dataAttribute) {
        return _regeneratorRuntime.wrap(function _callee145$(_context145) {
          while (1) {
            switch (_context145.prev = _context145.next) {
              case 0:
                return _context145.abrupt("return", this.requestService.post("projects/".concat(id, "/materialdeadlines"), payload).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('materialSelectionDeadlinesCreate', result);
                  }

                  return dataAttribute ? _defineProperty({}, dataAttribute, result.data) : result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context145.stop();
            }
          }
        }, _callee145, this);
      }));

      function materialSelectionDeadlinesCreate(_x252, _x253, _x254) {
        return _materialSelectionDeadlinesCreate.apply(this, arguments);
      }

      return materialSelectionDeadlinesCreate;
    }()
  }, {
    key: "materialSelectionDeadlinesDelete",
    value: function () {
      var _materialSelectionDeadlinesDelete = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee146(projectId, deadlineId, dataAttribute) {
        return _regeneratorRuntime.wrap(function _callee146$(_context146) {
          while (1) {
            switch (_context146.prev = _context146.next) {
              case 0:
                return _context146.abrupt("return", this.requestService.delete("projects/".concat(projectId, "/materialdeadlines/").concat(deadlineId)).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('materialSelectionDeadlinesDelete', result);
                  }

                  return dataAttribute ? _defineProperty({}, dataAttribute, result.data) : result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context146.stop();
            }
          }
        }, _callee146, this);
      }));

      function materialSelectionDeadlinesDelete(_x255, _x256, _x257) {
        return _materialSelectionDeadlinesDelete.apply(this, arguments);
      }

      return materialSelectionDeadlinesDelete;
    }()
  }, {
    key: "materialSelectionsGet",
    value: function () {
      var _materialSelectionsGet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee147(projectId, apartmentId, dataAttribute) {
        return _regeneratorRuntime.wrap(function _callee147$(_context147) {
          while (1) {
            switch (_context147.prev = _context147.next) {
              case 0:
                return _context147.abrupt("return", this.requestService.get("projects/".concat(projectId, "/apartments/").concat(apartmentId, "/materialselections")).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('materialSelectionsGet', result);
                  }

                  return dataAttribute ? _defineProperty({}, dataAttribute, result.data) : result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context147.stop();
            }
          }
        }, _callee147, this);
      }));

      function materialSelectionsGet(_x258, _x259, _x260) {
        return _materialSelectionsGet.apply(this, arguments);
      }

      return materialSelectionsGet;
    }()
  }, {
    key: "materialSelectionsPerSubmissionFormGet",
    value: function () {
      var _materialSelectionsPerSubmissionFormGet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee148(projectId, apartmentId, submissionID, dataAttribute) {
        return _regeneratorRuntime.wrap(function _callee148$(_context148) {
          while (1) {
            switch (_context148.prev = _context148.next) {
              case 0:
                return _context148.abrupt("return", this.requestService.get("projects/".concat(projectId, "/apartments/").concat(apartmentId, "/submissionForm/").concat(submissionID, "/materialselections")).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('materialSelectionsGet', result);
                  }

                  return dataAttribute ? _defineProperty({}, dataAttribute, result.data) : result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context148.stop();
            }
          }
        }, _callee148, this);
      }));

      function materialSelectionsPerSubmissionFormGet(_x261, _x262, _x263, _x264) {
        return _materialSelectionsPerSubmissionFormGet.apply(this, arguments);
      }

      return materialSelectionsPerSubmissionFormGet;
    }()
  }, {
    key: "materialSelectionsCreate",
    value: function () {
      var _materialSelectionsCreate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee149(payload) {
        return _regeneratorRuntime.wrap(function _callee149$(_context149) {
          while (1) {
            switch (_context149.prev = _context149.next) {
              case 0:
                return _context149.abrupt("return", this.requestService.post("materialFormSubmission", payload).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('materialSelectionsCreate', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context149.stop();
            }
          }
        }, _callee149, this);
      }));

      function materialSelectionsCreate(_x265) {
        return _materialSelectionsCreate.apply(this, arguments);
      }

      return materialSelectionsCreate;
    }()
  }, {
    key: "materialSelectionsUpdate",
    value: function () {
      var _materialSelectionsUpdate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee150(materialFormSubmissionId, payload) {
        return _regeneratorRuntime.wrap(function _callee150$(_context150) {
          while (1) {
            switch (_context150.prev = _context150.next) {
              case 0:
                return _context150.abrupt("return", this.requestService.put("materialFormSubmission/".concat(materialFormSubmissionId), payload).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('materialSelectionsUpdate', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context150.stop();
            }
          }
        }, _callee150, this);
      }));

      function materialSelectionsUpdate(_x266, _x267) {
        return _materialSelectionsUpdate.apply(this, arguments);
      }

      return materialSelectionsUpdate;
    }()
  }, {
    key: "materialSelectionsDelete",
    value: function () {
      var _materialSelectionsDelete = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee151(materialFormSubmissionId) {
        return _regeneratorRuntime.wrap(function _callee151$(_context151) {
          while (1) {
            switch (_context151.prev = _context151.next) {
              case 0:
                return _context151.abrupt("return", this.requestService.delete("materialFormSubmission/".concat(materialFormSubmissionId)).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('materialSelectionsDelete', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context151.stop();
            }
          }
        }, _callee151, this);
      }));

      function materialSelectionsDelete(_x268) {
        return _materialSelectionsDelete.apply(this, arguments);
      }

      return materialSelectionsDelete;
    }()
  }, {
    key: "materialFormSubmissionGet",
    value: function () {
      var _materialFormSubmissionGet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee152(apartmentId, materialFormId, dataAttribute) {
        return _regeneratorRuntime.wrap(function _callee152$(_context152) {
          while (1) {
            switch (_context152.prev = _context152.next) {
              case 0:
                return _context152.abrupt("return", this.requestService.get("materialFormSubmission/".concat(apartmentId, "/").concat(materialFormId)).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('materialFormSubmissionGet', result);
                  }

                  return dataAttribute ? _defineProperty({}, dataAttribute, result.data) : result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context152.stop();
            }
          }
        }, _callee152, this);
      }));

      function materialFormSubmissionGet(_x269, _x270, _x271) {
        return _materialFormSubmissionGet.apply(this, arguments);
      }

      return materialFormSubmissionGet;
    }()
  }, {
    key: "getMaterialFormSubmissionsByApartment",
    value: function () {
      var _getMaterialFormSubmissionsByApartment = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee153(apartmentId) {
        return _regeneratorRuntime.wrap(function _callee153$(_context153) {
          while (1) {
            switch (_context153.prev = _context153.next) {
              case 0:
                return _context153.abrupt("return", this.requestService.get("getMaterialFormSubmissionsByApartment/".concat(apartmentId)).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('getMaterialFormSubmissionsByApartment', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context153.stop();
            }
          }
        }, _callee153, this);
      }));

      function getMaterialFormSubmissionsByApartment(_x272) {
        return _getMaterialFormSubmissionsByApartment.apply(this, arguments);
      }

      return getMaterialFormSubmissionsByApartment;
    }()
  }, {
    key: "materialFormSubmissionSend",
    value: function () {
      var _materialFormSubmissionSend = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee154(materialFormId, payload) {
        return _regeneratorRuntime.wrap(function _callee154$(_context154) {
          while (1) {
            switch (_context154.prev = _context154.next) {
              case 0:
                return _context154.abrupt("return", this.requestService.post("materialFormSubmissionStatus/".concat(materialFormId), payload).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('materialFormSubmissionGet', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context154.stop();
            }
          }
        }, _callee154, this);
      }));

      function materialFormSubmissionSend(_x273, _x274) {
        return _materialFormSubmissionSend.apply(this, arguments);
      }

      return materialFormSubmissionSend;
    }()
  }, {
    key: "configurationGet",
    value: function () {
      var _configurationGet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee155() {
        return _regeneratorRuntime.wrap(function _callee155$(_context155) {
          while (1) {
            switch (_context155.prev = _context155.next) {
              case 0:
                return _context155.abrupt("return", this.requestService.rawGet('instance-configuration').then(function (config) {
                  if (_getResultError(config)) {
                    return _getResultError(config);
                  }

                  return config;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context155.stop();
            }
          }
        }, _callee155, this);
      }));

      function configurationGet() {
        return _configurationGet.apply(this, arguments);
      }

      return configurationGet;
    }()
  }, {
    key: "reportForProducts",
    value: function () {
      var _reportForProducts = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee156(projectId, stairwell) {
        return _regeneratorRuntime.wrap(function _callee156$(_context156) {
          while (1) {
            switch (_context156.prev = _context156.next) {
              case 0:
                return _context156.abrupt("return", this.requestService.rawGet("api/v1/projects/".concat(projectId, "/productreport/").concat(stairwell), {
                  tokenify: true,
                  text: true
                }).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  return result;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context156.stop();
            }
          }
        }, _callee156, this);
      }));

      function reportForProducts(_x275, _x276) {
        return _reportForProducts.apply(this, arguments);
      }

      return reportForProducts;
    }()
  }, {
    key: "reportForProject",
    value: function () {
      var _reportForProject = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee157(projectId) {
        return _regeneratorRuntime.wrap(function _callee157$(_context157) {
          while (1) {
            switch (_context157.prev = _context157.next) {
              case 0:
                return _context157.abrupt("return", this.requestService.get("projects/".concat(projectId, "/productreportforproject/")).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  return result;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context157.stop();
            }
          }
        }, _callee157, this);
      }));

      function reportForProject(_x277) {
        return _reportForProject.apply(this, arguments);
      }

      return reportForProject;
    }()
  }, {
    key: "termsGet",
    value: function () {
      var _termsGet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee158() {
        return _regeneratorRuntime.wrap(function _callee158$(_context158) {
          while (1) {
            switch (_context158.prev = _context158.next) {
              case 0:
                return _context158.abrupt("return", this.requestService.rawGet('api/v1/privacyterms').then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result) {
                    return _logicError('termsGet', result);
                  }

                  return result;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context158.stop();
            }
          }
        }, _callee158, this);
      }));

      function termsGet() {
        return _termsGet.apply(this, arguments);
      }

      return termsGet;
    }()
  }, {
    key: "userGet",
    value: function () {
      var _userGet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee159(id) {
        return _regeneratorRuntime.wrap(function _callee159$(_context159) {
          while (1) {
            switch (_context159.prev = _context159.next) {
              case 0:
                return _context159.abrupt("return", this.requestService.get("users/".concat(id)).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('userGet');
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context159.stop();
            }
          }
        }, _callee159, this);
      }));

      function userGet(_x278) {
        return _userGet.apply(this, arguments);
      }

      return userGet;
    }()
  }, {
    key: "usersGet",
    value: function () {
      var _usersGet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee160() {
        return _regeneratorRuntime.wrap(function _callee160$(_context160) {
          while (1) {
            switch (_context160.prev = _context160.next) {
              case 0:
                return _context160.abrupt("return", this.requestService.get('users?per_page=9999').then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('usersGet');
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context160.stop();
            }
          }
        }, _callee160, this);
      }));

      function usersGet() {
        return _usersGet.apply(this, arguments);
      }

      return usersGet;
    }()
  }, {
    key: "userTypesGet",
    value: function () {
      var _userTypesGet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee161(dataAttribute) {
        return _regeneratorRuntime.wrap(function _callee161$(_context161) {
          while (1) {
            switch (_context161.prev = _context161.next) {
              case 0:
                return _context161.abrupt("return", this.requestService.get('userTypes?per_page=9999').then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    _logicError('userTypesGet', result);
                  }

                  return dataAttribute ? _defineProperty({}, dataAttribute, result.data) : result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context161.stop();
            }
          }
        }, _callee161, this);
      }));

      function userTypesGet(_x279) {
        return _userTypesGet.apply(this, arguments);
      }

      return userTypesGet;
    }()
  }, {
    key: "userPhotoGet",
    value: function () {
      var _userPhotoGet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee162(id) {
        return _regeneratorRuntime.wrap(function _callee162$(_context162) {
          while (1) {
            switch (_context162.prev = _context162.next) {
              case 0:
                return _context162.abrupt("return", this.requestService.getImage("userphoto/".concat(id)).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result) {
                    return _logicError('userPhotoGet', result);
                  }

                  return new Promise(function (resolve, reject) {
                    var reader = new FileReader();
                    reader.readAsDataURL(result);

                    reader.onloadend = function () {
                      resolve(reader.result);
                    };
                  });
                }).catch(function () {
                  return {
                    error: true
                  };
                }));

              case 1:
              case "end":
                return _context162.stop();
            }
          }
        }, _callee162, this);
      }));

      function userPhotoGet(_x280) {
        return _userPhotoGet.apply(this, arguments);
      }

      return userPhotoGet;
    }()
  }, {
    key: "userPhotoCreate",
    value: function () {
      var _userPhotoCreate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee163(id, photo) {
        return _regeneratorRuntime.wrap(function _callee163$(_context163) {
          while (1) {
            switch (_context163.prev = _context163.next) {
              case 0:
                return _context163.abrupt("return", this.requestService.postUserPhoto("userphoto/".concat(id), photo).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result) {
                    return _logicError('userPhotoUpdate', result);
                  }

                  return result;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context163.stop();
            }
          }
        }, _callee163, this);
      }));

      function userPhotoCreate(_x281, _x282) {
        return _userPhotoCreate.apply(this, arguments);
      }

      return userPhotoCreate;
    }()
  }, {
    key: "userPhotoDelete",
    value: function () {
      var _userPhotoDelete = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee164(id) {
        return _regeneratorRuntime.wrap(function _callee164$(_context164) {
          while (1) {
            switch (_context164.prev = _context164.next) {
              case 0:
                return _context164.abrupt("return", this.requestService.delete("userphoto/".concat(id)).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result) {
                    return _logicError('userPhotoDelete', result);
                  }

                  return result;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context164.stop();
            }
          }
        }, _callee164, this);
      }));

      function userPhotoDelete(_x283) {
        return _userPhotoDelete.apply(this, arguments);
      }

      return userPhotoDelete;
    }()
  }, {
    key: "userPasswordChange",
    value: function () {
      var _userPasswordChange = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee165(payload) {
        return _regeneratorRuntime.wrap(function _callee165$(_context165) {
          while (1) {
            switch (_context165.prev = _context165.next) {
              case 0:
                return _context165.abrupt("return", this.requestService.post('user/change-password', payload).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  return result;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context165.stop();
            }
          }
        }, _callee165, this);
      }));

      function userPasswordChange(_x284) {
        return _userPasswordChange.apply(this, arguments);
      }

      return userPasswordChange;
    }()
  }, {
    key: "userPasswordManualChange",
    value: function () {
      var _userPasswordManualChange = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee166(payload) {
        return _regeneratorRuntime.wrap(function _callee166$(_context166) {
          while (1) {
            switch (_context166.prev = _context166.next) {
              case 0:
                return _context166.abrupt("return", this.requestService.post('user/manual-password', payload).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  return result;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context166.stop();
            }
          }
        }, _callee166, this);
      }));

      function userPasswordManualChange(_x285) {
        return _userPasswordManualChange.apply(this, arguments);
      }

      return userPasswordManualChange;
    }()
  }, {
    key: "userPasswordReset",
    value: function () {
      var _userPasswordReset = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee167(email) {
        var payload;
        return _regeneratorRuntime.wrap(function _callee167$(_context167) {
          while (1) {
            switch (_context167.prev = _context167.next) {
              case 0:
                payload = {
                  email: email
                };
                return _context167.abrupt("return", this.requestService.post('user/reset-password', payload).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  return result;
                }).catch(_catcherInTheCode));

              case 2:
              case "end":
                return _context167.stop();
            }
          }
        }, _callee167, this);
      }));

      function userPasswordReset(_x286) {
        return _userPasswordReset.apply(this, arguments);
      }

      return userPasswordReset;
    }()
  }, {
    key: "userCategoriesGet",
    value: function () {
      var _userCategoriesGet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee168() {
        return _regeneratorRuntime.wrap(function _callee168$(_context168) {
          while (1) {
            switch (_context168.prev = _context168.next) {
              case 0:
                return _context168.abrupt("return", this.requestService.get('usercategories').then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  return result;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context168.stop();
            }
          }
        }, _callee168, this);
      }));

      function userCategoriesGet() {
        return _userCategoriesGet.apply(this, arguments);
      }

      return userCategoriesGet;
    }()
  }, {
    key: "userCategoryCreate",
    value: function () {
      var _userCategoryCreate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee169(payload) {
        return _regeneratorRuntime.wrap(function _callee169$(_context169) {
          while (1) {
            switch (_context169.prev = _context169.next) {
              case 0:
                return _context169.abrupt("return", this.requestService.post('usercategories', payload).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  return result;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context169.stop();
            }
          }
        }, _callee169, this);
      }));

      function userCategoryCreate(_x287) {
        return _userCategoryCreate.apply(this, arguments);
      }

      return userCategoryCreate;
    }()
  }, {
    key: "userCategoryDelete",
    value: function () {
      var _userCategoryDelete = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee170(id) {
        return _regeneratorRuntime.wrap(function _callee170$(_context170) {
          while (1) {
            switch (_context170.prev = _context170.next) {
              case 0:
                return _context170.abrupt("return", this.requestService.delete("usercategories/".concat(id)).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  return result;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context170.stop();
            }
          }
        }, _callee170, this);
      }));

      function userCategoryDelete(_x288) {
        return _userCategoryDelete.apply(this, arguments);
      }

      return userCategoryDelete;
    }()
  }, {
    key: "companiesGet",
    value: function () {
      var _companiesGet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee171(dataAttribute) {
        return _regeneratorRuntime.wrap(function _callee171$(_context171) {
          while (1) {
            switch (_context171.prev = _context171.next) {
              case 0:
                return _context171.abrupt("return", this.requestService.get('companies?per_page=9999').then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('companiesGet');
                  }

                  return dataAttribute ? _defineProperty({}, dataAttribute, result.data) : result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context171.stop();
            }
          }
        }, _callee171, this);
      }));

      function companiesGet(_x289) {
        return _companiesGet.apply(this, arguments);
      }

      return companiesGet;
    }()
  }, {
    key: "companyGet",
    value: function () {
      var _companyGet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee172(id) {
        return _regeneratorRuntime.wrap(function _callee172$(_context172) {
          while (1) {
            switch (_context172.prev = _context172.next) {
              case 0:
                return _context172.abrupt("return", this.requestService.get("companies/".concat(id)).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('companyGet');
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context172.stop();
            }
          }
        }, _callee172, this);
      }));

      function companyGet(_x290) {
        return _companyGet.apply(this, arguments);
      }

      return companyGet;
    }()
  }, {
    key: "companyCreate",
    value: function () {
      var _companyCreate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee173(company) {
        return _regeneratorRuntime.wrap(function _callee173$(_context173) {
          while (1) {
            switch (_context173.prev = _context173.next) {
              case 0:
                return _context173.abrupt("return", this.requestService.post('companies', company).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('companyCreate', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context173.stop();
            }
          }
        }, _callee173, this);
      }));

      function companyCreate(_x291) {
        return _companyCreate.apply(this, arguments);
      }

      return companyCreate;
    }()
  }, {
    key: "companyUpdate",
    value: function () {
      var _companyUpdate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee174(company) {
        return _regeneratorRuntime.wrap(function _callee174$(_context174) {
          while (1) {
            switch (_context174.prev = _context174.next) {
              case 0:
                return _context174.abrupt("return", this.requestService.put("companies/".concat(company.id), company).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('companyDelete', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context174.stop();
            }
          }
        }, _callee174, this);
      }));

      function companyUpdate(_x292) {
        return _companyUpdate.apply(this, arguments);
      }

      return companyUpdate;
    }()
  }, {
    key: "companyDelete",
    value: function () {
      var _companyDelete = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee175(company) {
        return _regeneratorRuntime.wrap(function _callee175$(_context175) {
          while (1) {
            switch (_context175.prev = _context175.next) {
              case 0:
                return _context175.abrupt("return", this.requestService.delete("companies/".concat(company.id)).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('companyDelete', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context175.stop();
            }
          }
        }, _callee175, this);
      }));

      function companyDelete(_x293) {
        return _companyDelete.apply(this, arguments);
      }

      return companyDelete;
    }()
  }, {
    key: "companyUsersCreate",
    value: function () {
      var _companyUsersCreate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee176(company, user) {
        return _regeneratorRuntime.wrap(function _callee176$(_context176) {
          while (1) {
            switch (_context176.prev = _context176.next) {
              case 0:
                return _context176.abrupt("return", this.requestService.post("companies/".concat(company.id, "/users"), user).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('companyUsersCreate', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context176.stop();
            }
          }
        }, _callee176, this);
      }));

      function companyUsersCreate(_x294, _x295) {
        return _companyUsersCreate.apply(this, arguments);
      }

      return companyUsersCreate;
    }()
  }, {
    key: "companyUsersUpdate",
    value: function () {
      var _companyUsersUpdate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee177(company, user) {
        return _regeneratorRuntime.wrap(function _callee177$(_context177) {
          while (1) {
            switch (_context177.prev = _context177.next) {
              case 0:
                return _context177.abrupt("return", this.requestService.put("companies/".concat(company.id, "/users/").concat(user.id), user).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('companyUsersUpdate', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context177.stop();
            }
          }
        }, _callee177, this);
      }));

      function companyUsersUpdate(_x296, _x297) {
        return _companyUsersUpdate.apply(this, arguments);
      }

      return companyUsersUpdate;
    }()
  }, {
    key: "companyUsersSetPassword",
    value: function () {
      var _companyUsersSetPassword = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee178(user, company, newPassword) {
        return _regeneratorRuntime.wrap(function _callee178$(_context178) {
          while (1) {
            switch (_context178.prev = _context178.next) {
              case 0:
                return _context178.abrupt("return", this.requestService.put("companies/".concat(company.id, "/users/").concat(user.id, "/resetpassword"), newPassword).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('companyUsersSetPassword', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context178.stop();
            }
          }
        }, _callee178, this);
      }));

      function companyUsersSetPassword(_x298, _x299, _x300) {
        return _companyUsersSetPassword.apply(this, arguments);
      }

      return companyUsersSetPassword;
    }()
  }, {
    key: "companyUsersDelete",
    value: function () {
      var _companyUsersDelete = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee179(company, user) {
        return _regeneratorRuntime.wrap(function _callee179$(_context179) {
          while (1) {
            switch (_context179.prev = _context179.next) {
              case 0:
                if (!(!company || !user)) {
                  _context179.next = 2;
                  break;
                }

                return _context179.abrupt("return", {
                  error: 'Invalid input, need ID and user!'
                });

              case 2:
                return _context179.abrupt("return", this.requestService.delete("companies/".concat(company.id, "/users/").concat(user.id)).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('companyUsersDelete', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 3:
              case "end":
                return _context179.stop();
            }
          }
        }, _callee179, this);
      }));

      function companyUsersDelete(_x301, _x302) {
        return _companyUsersDelete.apply(this, arguments);
      }

      return companyUsersDelete;
    }()
  }, {
    key: "companyUsersGet",
    value: function () {
      var _companyUsersGet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee180(companyId) {
        return _regeneratorRuntime.wrap(function _callee180$(_context180) {
          while (1) {
            switch (_context180.prev = _context180.next) {
              case 0:
                return _context180.abrupt("return", this.requestService.get("companies/".concat(companyId, "/users")).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('companyUsersGet', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context180.stop();
            }
          }
        }, _callee180, this);
      }));

      function companyUsersGet(_x303) {
        return _companyUsersGet.apply(this, arguments);
      }

      return companyUsersGet;
    }()
  }, {
    key: "companyUserRoleAdd",
    value: function () {
      var _companyUserRoleAdd = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee181(companyId, userId, roleId) {
        var payload;
        return _regeneratorRuntime.wrap(function _callee181$(_context181) {
          while (1) {
            switch (_context181.prev = _context181.next) {
              case 0:
                payload = {
                  id: roleId
                };
                return _context181.abrupt("return", this.requestService.post("companies/".concat(companyId, "/users/").concat(userId, "/roles"), payload).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('companyUserRoleAdd', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 2:
              case "end":
                return _context181.stop();
            }
          }
        }, _callee181, this);
      }));

      function companyUserRoleAdd(_x304, _x305, _x306) {
        return _companyUserRoleAdd.apply(this, arguments);
      }

      return companyUserRoleAdd;
    }()
  }, {
    key: "companyUserRoleRemove",
    value: function () {
      var _companyUserRoleRemove = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee182(companyId, userId, roleId) {
        return _regeneratorRuntime.wrap(function _callee182$(_context182) {
          while (1) {
            switch (_context182.prev = _context182.next) {
              case 0:
                return _context182.abrupt("return", this.requestService.delete("companies/".concat(companyId, "/users/").concat(userId, "/roles/").concat(roleId)).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('companyUserRoleRemove', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context182.stop();
            }
          }
        }, _callee182, this);
      }));

      function companyUserRoleRemove(_x307, _x308, _x309) {
        return _companyUserRoleRemove.apply(this, arguments);
      }

      return companyUserRoleRemove;
    }()
  }, {
    key: "fieldsGet",
    value: function () {
      var _fieldsGet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee183(dataAttribute) {
        return _regeneratorRuntime.wrap(function _callee183$(_context183) {
          while (1) {
            switch (_context183.prev = _context183.next) {
              case 0:
                return _context183.abrupt("return", this.requestService.get('fields?per_page=9999').then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    _logicError('fieldsGet', result);
                  }

                  return dataAttribute ? _defineProperty({}, dataAttribute, result.data) : result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context183.stop();
            }
          }
        }, _callee183, this);
      }));

      function fieldsGet(_x310) {
        return _fieldsGet.apply(this, arguments);
      }

      return fieldsGet;
    }()
  }, {
    key: "keywordsGet",
    value: function () {
      var _keywordsGet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee184(dataAttribute) {
        return _regeneratorRuntime.wrap(function _callee184$(_context184) {
          while (1) {
            switch (_context184.prev = _context184.next) {
              case 0:
                return _context184.abrupt("return", this.requestService.get('allKeywords?per_page=9999').then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    _logicError('keywordsGet', result);
                  }

                  return dataAttribute ? _defineProperty({}, dataAttribute, result.data) : result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context184.stop();
            }
          }
        }, _callee184, this);
      }));

      function keywordsGet(_x311) {
        return _keywordsGet.apply(this, arguments);
      }

      return keywordsGet;
    }()
  }, {
    key: "companyTypesGet",
    value: function () {
      var _companyTypesGet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee185(dataAttribute) {
        return _regeneratorRuntime.wrap(function _callee185$(_context185) {
          while (1) {
            switch (_context185.prev = _context185.next) {
              case 0:
                return _context185.abrupt("return", this.requestService.get('companyTypes?per_page=9999').then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    _logicError('companyTypesGet', result);
                  }

                  return dataAttribute ? _defineProperty({}, dataAttribute, result.data) : result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context185.stop();
            }
          }
        }, _callee185, this);
      }));

      function companyTypesGet(_x312) {
        return _companyTypesGet.apply(this, arguments);
      }

      return companyTypesGet;
    }()
  }, {
    key: "rolesGet",
    value: function () {
      var _rolesGet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee186() {
        return _regeneratorRuntime.wrap(function _callee186$(_context186) {
          while (1) {
            switch (_context186.prev = _context186.next) {
              case 0:
                return _context186.abrupt("return", this.requestService.get('roles?per_page=9999').then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    _logicError('rolesGet', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context186.stop();
            }
          }
        }, _callee186, this);
      }));

      function rolesGet() {
        return _rolesGet.apply(this, arguments);
      }

      return rolesGet;
    }()
  }, {
    key: "rolesTypedGet",
    value: function () {
      var _rolesTypedGet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee187(dataAttribute) {
        return _regeneratorRuntime.wrap(function _callee187$(_context187) {
          while (1) {
            switch (_context187.prev = _context187.next) {
              case 0:
                return _context187.abrupt("return", this.requestService.get('roles_typed').then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    _logicError('rolesTypedGet', result);
                  }

                  return dataAttribute ? _defineProperty({}, dataAttribute, result.data) : result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context187.stop();
            }
          }
        }, _callee187, this);
      }));

      function rolesTypedGet(_x313) {
        return _rolesTypedGet.apply(this, arguments);
      }

      return rolesTypedGet;
    }()
  }, {
    key: "documentGet",
    value: function () {
      var _documentGet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee188(id, dataAttribute) {
        return _regeneratorRuntime.wrap(function _callee188$(_context188) {
          while (1) {
            switch (_context188.prev = _context188.next) {
              case 0:
                return _context188.abrupt("return", this.requestService.get('documents/' + id).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    _logicError('documentGet', result);
                  }

                  return dataAttribute ? _defineProperty({}, dataAttribute, result.data) : result.data;
                }));

              case 1:
              case "end":
                return _context188.stop();
            }
          }
        }, _callee188, this);
      }));

      function documentGet(_x314, _x315) {
        return _documentGet.apply(this, arguments);
      }

      return documentGet;
    }()
  }, {
    key: "documentDeleteRequestsGet",
    value: function () {
      var _documentDeleteRequestsGet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee189() {
        return _regeneratorRuntime.wrap(function _callee189$(_context189) {
          while (1) {
            switch (_context189.prev = _context189.next) {
              case 0:
                return _context189.abrupt("return", this.requestService.get('document-delete-requests?per_page=9999').then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('documentDeleteRequestsGet');
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context189.stop();
            }
          }
        }, _callee189, this);
      }));

      function documentDeleteRequestsGet() {
        return _documentDeleteRequestsGet.apply(this, arguments);
      }

      return documentDeleteRequestsGet;
    }()
  }, {
    key: "documentDeleteRequestCreate",
    value: function () {
      var _documentDeleteRequestCreate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee190(id) {
        var payload;
        return _regeneratorRuntime.wrap(function _callee190$(_context190) {
          while (1) {
            switch (_context190.prev = _context190.next) {
              case 0:
                payload = {
                  document_id: id
                };
                return _context190.abrupt("return", this.requestService.post('document-delete-requests', payload).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('documentDeleteRequestCreate', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 2:
              case "end":
                return _context190.stop();
            }
          }
        }, _callee190, this);
      }));

      function documentDeleteRequestCreate(_x316) {
        return _documentDeleteRequestCreate.apply(this, arguments);
      }

      return documentDeleteRequestCreate;
    }()
  }, {
    key: "documentDeleteRequestAccept",
    value: function () {
      var _documentDeleteRequestAccept = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee191(payload) {
        return _regeneratorRuntime.wrap(function _callee191$(_context191) {
          while (1) {
            switch (_context191.prev = _context191.next) {
              case 0:
                if (payload) {
                  _context191.next = 2;
                  break;
                }

                return _context191.abrupt("return", {
                  error: 'Invalid input, need d!'
                });

              case 2:
                return _context191.abrupt("return", this.requestService.post("document-delete-requests/".concat(payload.id, "/accept")).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('documentDeleteRequestAccept', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 3:
              case "end":
                return _context191.stop();
            }
          }
        }, _callee191, this);
      }));

      function documentDeleteRequestAccept(_x317) {
        return _documentDeleteRequestAccept.apply(this, arguments);
      }

      return documentDeleteRequestAccept;
    }()
  }, {
    key: "documentDeleteRequestReject",
    value: function () {
      var _documentDeleteRequestReject = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee192(payload) {
        return _regeneratorRuntime.wrap(function _callee192$(_context192) {
          while (1) {
            switch (_context192.prev = _context192.next) {
              case 0:
                if (payload) {
                  _context192.next = 2;
                  break;
                }

                return _context192.abrupt("return", {
                  error: 'Invalid input, need payload!'
                });

              case 2:
                return _context192.abrupt("return", this.requestService.delete("document-delete-requests/".concat(payload.id)).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('documentDeleteRequestReject', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 3:
              case "end":
                return _context192.stop();
            }
          }
        }, _callee192, this);
      }));

      function documentDeleteRequestReject(_x318) {
        return _documentDeleteRequestReject.apply(this, arguments);
      }

      return documentDeleteRequestReject;
    }()
  }, {
    key: "documentTypesGet",
    value: function () {
      var _documentTypesGet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee193(dataAttribute) {
        return _regeneratorRuntime.wrap(function _callee193$(_context193) {
          while (1) {
            switch (_context193.prev = _context193.next) {
              case 0:
                return _context193.abrupt("return", this.requestService.get('document-types').then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('getDocumentTypes', result);
                  }

                  return dataAttribute ? _defineProperty({}, dataAttribute, result.data) : result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context193.stop();
            }
          }
        }, _callee193, this);
      }));

      function documentTypesGet(_x319) {
        return _documentTypesGet.apply(this, arguments);
      }

      return documentTypesGet;
    }()
  }, {
    key: "documentTypesCreate",
    value: function () {
      var _documentTypesCreate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee194(name) {
        var payload;
        return _regeneratorRuntime.wrap(function _callee194$(_context194) {
          while (1) {
            switch (_context194.prev = _context194.next) {
              case 0:
                payload = {
                  name: name,
                  is_immutable: false,
                  // TODO
                  is_default: false,
                  // TODO
                  is_active: true // TODO

                };
                return _context194.abrupt("return", this.requestService.post('document-types', payload).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('documentTypesCreate', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 2:
              case "end":
                return _context194.stop();
            }
          }
        }, _callee194, this);
      }));

      function documentTypesCreate(_x320) {
        return _documentTypesCreate.apply(this, arguments);
      }

      return documentTypesCreate;
    }()
  }, {
    key: "documentTypesDelete",
    value: function () {
      var _documentTypesDelete = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee195(id) {
        return _regeneratorRuntime.wrap(function _callee195$(_context195) {
          while (1) {
            switch (_context195.prev = _context195.next) {
              case 0:
                return _context195.abrupt("return", this.requestService.delete("document-types/".concat(id)).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result) {
                    return _logicError('userPhotoDelete', result);
                  }

                  return result;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context195.stop();
            }
          }
        }, _callee195, this);
      }));

      function documentTypesDelete(_x321) {
        return _documentTypesDelete.apply(this, arguments);
      }

      return documentTypesDelete;
    }()
  }, {
    key: "documentTypesUpdate",
    value: function () {
      var _documentTypesUpdate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee196(id, payload) {
        return _regeneratorRuntime.wrap(function _callee196$(_context196) {
          while (1) {
            switch (_context196.prev = _context196.next) {
              case 0:
                return _context196.abrupt("return", this.requestService.put("document-types/".concat(id), payload).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('documentTypesUpdate', result);
                  }

                  return result;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context196.stop();
            }
          }
        }, _callee196, this);
      }));

      function documentTypesUpdate(_x322, _x323) {
        return _documentTypesUpdate.apply(this, arguments);
      }

      return documentTypesUpdate;
    }()
  }, {
    key: "documentTypeFieldsUpdate",
    value: function () {
      var _documentTypeFieldsUpdate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee197(id, payload) {
        return _regeneratorRuntime.wrap(function _callee197$(_context197) {
          while (1) {
            switch (_context197.prev = _context197.next) {
              case 0:
                return _context197.abrupt("return", this.requestService.put("document-types/".concat(id, "/fields"), payload).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('documentTypesUpdate', result);
                  }

                  return result;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context197.stop();
            }
          }
        }, _callee197, this);
      }));

      function documentTypeFieldsUpdate(_x324, _x325) {
        return _documentTypeFieldsUpdate.apply(this, arguments);
      }

      return documentTypeFieldsUpdate;
    }()
  }, {
    key: "fieldCreate",
    value: function () {
      var _fieldCreate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee198(_ref62) {
        var fieldName, fieldType, keywords, showInDocumentsTable, payload;
        return _regeneratorRuntime.wrap(function _callee198$(_context198) {
          while (1) {
            switch (_context198.prev = _context198.next) {
              case 0:
                fieldName = _ref62.fieldName, fieldType = _ref62.fieldType, keywords = _ref62.keywords, showInDocumentsTable = _ref62.showInDocumentsTable;
                payload = {
                  key: fieldName,
                  type: fieldType,
                  keywords: keywords,
                  show_in_documents_table: false // Will this be used or not?

                };
                return _context198.abrupt("return", this.requestService.post('fields', payload).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('fieldCreate', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 3:
              case "end":
                return _context198.stop();
            }
          }
        }, _callee198, this);
      }));

      function fieldCreate(_x326) {
        return _fieldCreate.apply(this, arguments);
      }

      return fieldCreate;
    }()
  }, {
    key: "fieldUpdate",
    value: function () {
      var _fieldUpdate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee199(id, _ref63) {
        var fieldName, fieldType, keywords, payload;
        return _regeneratorRuntime.wrap(function _callee199$(_context199) {
          while (1) {
            switch (_context199.prev = _context199.next) {
              case 0:
                fieldName = _ref63.fieldName, fieldType = _ref63.fieldType, keywords = _ref63.keywords;
                payload = {
                  key: fieldName,
                  type: fieldType,
                  keywords: keywords,
                  show_in_documents_table: true
                };
                return _context199.abrupt("return", this.requestService.put("fields/".concat(id), payload).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('fieldUpdate', result);
                  }

                  return result;
                }).catch(_catcherInTheCode));

              case 3:
              case "end":
                return _context199.stop();
            }
          }
        }, _callee199, this);
      }));

      function fieldUpdate(_x327, _x328) {
        return _fieldUpdate.apply(this, arguments);
      }

      return fieldUpdate;
    }()
  }, {
    key: "fieldDelete",
    value: function () {
      var _fieldDelete = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee200(id) {
        return _regeneratorRuntime.wrap(function _callee200$(_context200) {
          while (1) {
            switch (_context200.prev = _context200.next) {
              case 0:
                return _context200.abrupt("return", this.requestService.delete("fields/".concat(id)).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result) {
                    return _logicError('fieldDelete', result);
                  }

                  return result;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context200.stop();
            }
          }
        }, _callee200, this);
      }));

      function fieldDelete(_x329) {
        return _fieldDelete.apply(this, arguments);
      }

      return fieldDelete;
    }()
  }, {
    key: "keywordUpdate",
    value: function () {
      var _keywordUpdate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee201(payload) {
        return _regeneratorRuntime.wrap(function _callee201$(_context201) {
          while (1) {
            switch (_context201.prev = _context201.next) {
              case 0:
                return _context201.abrupt("return", this.requestService.put("fields/0/keywords/".concat(payload.keyword), payload).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('keywordUpdate', result);
                  }

                  return result;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context201.stop();
            }
          }
        }, _callee201, this);
      }));

      function keywordUpdate(_x330) {
        return _keywordUpdate.apply(this, arguments);
      }

      return keywordUpdate;
    }()
  }, {
    key: "keywordDelete",
    value: function () {
      var _keywordDelete = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee202(id) {
        return _regeneratorRuntime.wrap(function _callee202$(_context202) {
          while (1) {
            switch (_context202.prev = _context202.next) {
              case 0:
                return _context202.abrupt("return", this.requestService.delete("fields/0/keywords/".concat(id)).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result) {
                    return _logicError('keywordDelete', result);
                  }

                  return result;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context202.stop();
            }
          }
        }, _callee202, this);
      }));

      function keywordDelete(_x331) {
        return _keywordDelete.apply(this, arguments);
      }

      return keywordDelete;
    }()
  }, {
    key: "notificationGet",
    value: function () {
      var _notificationGet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee203() {
        return _regeneratorRuntime.wrap(function _callee203$(_context203) {
          while (1) {
            switch (_context203.prev = _context203.next) {
              case 0:
                return _context203.abrupt("return", this.requestService.get('notifications?per_page=9999').then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('notificationGet', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context203.stop();
            }
          }
        }, _callee203, this);
      }));

      function notificationGet() {
        return _notificationGet.apply(this, arguments);
      }

      return notificationGet;
    }()
  }, {
    key: "notificationGetLatest",
    value: function () {
      var _notificationGetLatest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee204() {
        return _regeneratorRuntime.wrap(function _callee204$(_context204) {
          while (1) {
            switch (_context204.prev = _context204.next) {
              case 0:
                return _context204.abrupt("return", this.requestService.get('notifications/latest').then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('notificationGet', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context204.stop();
            }
          }
        }, _callee204, this);
      }));

      function notificationGetLatest() {
        return _notificationGetLatest.apply(this, arguments);
      }

      return notificationGetLatest;
    }()
  }, {
    key: "apartmentNotificationsGet",
    value: function () {
      var _apartmentNotificationsGet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee205(apartmentId, dataAttribute) {
        return _regeneratorRuntime.wrap(function _callee205$(_context205) {
          while (1) {
            switch (_context205.prev = _context205.next) {
              case 0:
                return _context205.abrupt("return", this.requestService.get("apartment/".concat(apartmentId, "/notifications")).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('apartmentNotificationsGet', result);
                  }

                  return dataAttribute ? _defineProperty({}, dataAttribute, result.data) : result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context205.stop();
            }
          }
        }, _callee205, this);
      }));

      function apartmentNotificationsGet(_x332, _x333) {
        return _apartmentNotificationsGet.apply(this, arguments);
      }

      return apartmentNotificationsGet;
    }()
  }, {
    key: "condominiumNotificationsGet",
    value: function () {
      var _condominiumNotificationsGet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee206(condominiumId, dataAttribute) {
        return _regeneratorRuntime.wrap(function _callee206$(_context206) {
          while (1) {
            switch (_context206.prev = _context206.next) {
              case 0:
                return _context206.abrupt("return", this.requestService.get("condominium/".concat(condominiumId, "/notifications")).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('condominiumNotificationsGet', result);
                  }

                  return dataAttribute ? _defineProperty({}, dataAttribute, result.data) : result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context206.stop();
            }
          }
        }, _callee206, this);
      }));

      function condominiumNotificationsGet(_x334, _x335) {
        return _condominiumNotificationsGet.apply(this, arguments);
      }

      return condominiumNotificationsGet;
    }()
  }, {
    key: "globalNotificationsGet",
    value: function () {
      var _globalNotificationsGet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee207(condominiumId, dataAttribute) {
        return _regeneratorRuntime.wrap(function _callee207$(_context207) {
          while (1) {
            switch (_context207.prev = _context207.next) {
              case 0:
                return _context207.abrupt("return", this.requestService.get("notifications/global").then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('globalNotificationsGet', result);
                  }

                  return dataAttribute ? _defineProperty({}, dataAttribute, result.data) : result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context207.stop();
            }
          }
        }, _callee207, this);
      }));

      function globalNotificationsGet(_x336, _x337) {
        return _globalNotificationsGet.apply(this, arguments);
      }

      return globalNotificationsGet;
    }()
  }, {
    key: "notificationCreate",
    value: function () {
      var _notificationCreate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee208(payload) {
        var options;
        return _regeneratorRuntime.wrap(function _callee208$(_context208) {
          while (1) {
            switch (_context208.prev = _context208.next) {
              case 0:
                options = {
                  indices: true,
                  nullsAsUndefineds: false,
                  booleansAsIntegers: true
                };
                return _context208.abrupt("return", this.requestService.post('notifications', objectToFormData(payload, options)).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('notificationsCreate', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 2:
              case "end":
                return _context208.stop();
            }
          }
        }, _callee208, this);
      }));

      function notificationCreate(_x338) {
        return _notificationCreate.apply(this, arguments);
      }

      return notificationCreate;
    }()
  }, {
    key: "notificationEdit",
    value: function () {
      var _notificationEdit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee209(payload, id) {
        var isPublished;
        return _regeneratorRuntime.wrap(function _callee209$(_context209) {
          while (1) {
            switch (_context209.prev = _context209.next) {
              case 0:
                isPublished = payload.is_published;

                if (isPublished === true || isPublished === 1) {
                  payload.is_published = 1;
                } else {
                  payload.is_published = 0;
                }

                return _context209.abrupt("return", this.requestService.put("notifications/".concat(id), payload).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('notificationsCreate', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 3:
              case "end":
                return _context209.stop();
            }
          }
        }, _callee209, this);
      }));

      function notificationEdit(_x339, _x340) {
        return _notificationEdit.apply(this, arguments);
      }

      return notificationEdit;
    }()
  }, {
    key: "notificationDelete",
    value: function () {
      var _notificationDelete = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee210(id) {
        return _regeneratorRuntime.wrap(function _callee210$(_context210) {
          while (1) {
            switch (_context210.prev = _context210.next) {
              case 0:
                return _context210.abrupt("return", this.requestService.delete("notifications/".concat(id)).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('notificationDelete', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context210.stop();
            }
          }
        }, _callee210, this);
      }));

      function notificationDelete(_x341) {
        return _notificationDelete.apply(this, arguments);
      }

      return notificationDelete;
    }()
  }, {
    key: "deleteDocuments",
    value: function () {
      var _deleteDocuments = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee211(ids, projectId) {
        var payload;
        return _regeneratorRuntime.wrap(function _callee211$(_context211) {
          while (1) {
            switch (_context211.prev = _context211.next) {
              case 0:
                payload = {
                  ids: ids
                };
                return _context211.abrupt("return", this.requestService.post("projects/".concat(projectId, "/documents/delete"), payload).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('deleteDocuments', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 2:
              case "end":
                return _context211.stop();
            }
          }
        }, _callee211, this);
      }));

      function deleteDocuments(_x342, _x343) {
        return _deleteDocuments.apply(this, arguments);
      }

      return deleteDocuments;
    }()
  }, {
    key: "search",
    value: function () {
      var _search = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee212(payload) {
        return _regeneratorRuntime.wrap(function _callee212$(_context212) {
          while (1) {
            switch (_context212.prev = _context212.next) {
              case 0:
                if (payload) {
                  _context212.next = 2;
                  break;
                }

                return _context212.abrupt("return", {
                  error: 'payload is mandatory'
                });

              case 2:
                if (payload.query) {
                  _context212.next = 4;
                  break;
                }

                return _context212.abrupt("return", {
                  error: 'payload must contain query'
                });

              case 4:
                return _context212.abrupt("return", this.requestService.post('search', payload).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('search', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 5:
              case "end":
                return _context212.stop();
            }
          }
        }, _callee212, this);
      }));

      function search(_x344) {
        return _search.apply(this, arguments);
      }

      return search;
    }()
  }, {
    key: "searchResultDetails",
    value: function () {
      var _searchResultDetails = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee213(documentId, query) {
        return _regeneratorRuntime.wrap(function _callee213$(_context213) {
          while (1) {
            switch (_context213.prev = _context213.next) {
              case 0:
                if (documentId) {
                  _context213.next = 2;
                  break;
                }

                return _context213.abrupt("return", {
                  error: 'documentId is mandatory'
                });

              case 2:
                return _context213.abrupt("return", this.requestService.get('searchResultDetails/' + documentId + '/' + query).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('searchResultDetails', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 3:
              case "end":
                return _context213.stop();
            }
          }
        }, _callee213, this);
      }));

      function searchResultDetails(_x345, _x346) {
        return _searchResultDetails.apply(this, arguments);
      }

      return searchResultDetails;
    }()
  }, {
    key: "projectStatusesGet",
    value: function () {
      var _projectStatusesGet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee214(dataAttribute) {
        return _regeneratorRuntime.wrap(function _callee214$(_context214) {
          while (1) {
            switch (_context214.prev = _context214.next) {
              case 0:
                return _context214.abrupt("return", this.requestService.get('project-statuses').then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    _logicError('projectStatusesGet', result);
                  }

                  return dataAttribute ? _defineProperty({}, dataAttribute, result.data) : result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context214.stop();
            }
          }
        }, _callee214, this);
      }));

      function projectStatusesGet(_x347) {
        return _projectStatusesGet.apply(this, arguments);
      }

      return projectStatusesGet;
    }()
  }, {
    key: "projectStatusEdit",
    value: function () {
      var _projectStatusEdit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee215(payload, id) {
        return _regeneratorRuntime.wrap(function _callee215$(_context215) {
          while (1) {
            switch (_context215.prev = _context215.next) {
              case 0:
                return _context215.abrupt("return", this.requestService.put("project-statuses/".concat(id, "/edit"), payload).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    _logicError('projectStatusEdit', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context215.stop();
            }
          }
        }, _callee215, this);
      }));

      function projectStatusEdit(_x348, _x349) {
        return _projectStatusEdit.apply(this, arguments);
      }

      return projectStatusEdit;
    }()
  }, {
    key: "projectStatusAdd",
    value: function () {
      var _projectStatusAdd = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee216(payload) {
        return _regeneratorRuntime.wrap(function _callee216$(_context216) {
          while (1) {
            switch (_context216.prev = _context216.next) {
              case 0:
                return _context216.abrupt("return", this.requestService.post("project-statuses/add", payload).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    _logicError('projectStatusAdd', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context216.stop();
            }
          }
        }, _callee216, this);
      }));

      function projectStatusAdd(_x350) {
        return _projectStatusAdd.apply(this, arguments);
      }

      return projectStatusAdd;
    }()
  }, {
    key: "projectsWithStatusGet",
    value: function () {
      var _projectsWithStatusGet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee217(id) {
        return _regeneratorRuntime.wrap(function _callee217$(_context217) {
          while (1) {
            switch (_context217.prev = _context217.next) {
              case 0:
                return _context217.abrupt("return", this.requestService.get("project-statuses/projects/".concat(id)).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    _logicError('projectsWithStatusGet', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context217.stop();
            }
          }
        }, _callee217, this);
      }));

      function projectsWithStatusGet(_x351) {
        return _projectsWithStatusGet.apply(this, arguments);
      }

      return projectsWithStatusGet;
    }()
  }, {
    key: "projectStatusDelete",
    value: function () {
      var _projectStatusDelete = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee218(id) {
        return _regeneratorRuntime.wrap(function _callee218$(_context218) {
          while (1) {
            switch (_context218.prev = _context218.next) {
              case 0:
                return _context218.abrupt("return", this.requestService.delete("project-statuses/".concat(id, "/delete")).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    _logicError('projectStatusDelete', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context218.stop();
            }
          }
        }, _callee218, this);
      }));

      function projectStatusDelete(_x352) {
        return _projectStatusDelete.apply(this, arguments);
      }

      return projectStatusDelete;
    }()
  }, {
    key: "projectStatusGet",
    value: function () {
      var _projectStatusGet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee219(id) {
        return _regeneratorRuntime.wrap(function _callee219$(_context219) {
          while (1) {
            switch (_context219.prev = _context219.next) {
              case 0:
                return _context219.abrupt("return", this.requestService.get("project-statuses/".concat(id)).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result) {
                    _logicError('projectStatusGet', result);
                  }

                  return result;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context219.stop();
            }
          }
        }, _callee219, this);
      }));

      function projectStatusGet(_x353) {
        return _projectStatusGet.apply(this, arguments);
      }

      return projectStatusGet;
    }()
  }, {
    key: "getCondominiumUsers",
    value: function () {
      var _getCondominiumUsers = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee220(condominiumId) {
        return _regeneratorRuntime.wrap(function _callee220$(_context220) {
          while (1) {
            switch (_context220.prev = _context220.next) {
              case 0:
                return _context220.abrupt("return", this.requestService.get("condominium/".concat(condominiumId, "/users")).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result) {
                    _logicError('projectStatusGet', result);
                  }

                  return result;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context220.stop();
            }
          }
        }, _callee220, this);
      }));

      function getCondominiumUsers(_x354) {
        return _getCondominiumUsers.apply(this, arguments);
      }

      return getCondominiumUsers;
    }()
  }, {
    key: "modifyCondominiumUsersRole",
    value: function () {
      var _modifyCondominiumUsersRole = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee221(condominiumId, userId) {
        return _regeneratorRuntime.wrap(function _callee221$(_context221) {
          while (1) {
            switch (_context221.prev = _context221.next) {
              case 0:
                return _context221.abrupt("return", this.requestService.get("condominium/".concat(condominiumId, "/user/").concat(userId, "/modifyRole")).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result) {
                    _logicError('projectStatusGet', result);
                  }

                  return result;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context221.stop();
            }
          }
        }, _callee221, this);
      }));

      function modifyCondominiumUsersRole(_x355, _x356) {
        return _modifyCondominiumUsersRole.apply(this, arguments);
      }

      return modifyCondominiumUsersRole;
    }()
  }, {
    key: "condominiumUserCreate",
    value: function () {
      var _condominiumUserCreate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee222(id, payload) {
        return _regeneratorRuntime.wrap(function _callee222$(_context222) {
          while (1) {
            switch (_context222.prev = _context222.next) {
              case 0:
                return _context222.abrupt("return", this.requestService.post("condominium/".concat(id, "/users"), payload).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('condominiumUserCreate', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context222.stop();
            }
          }
        }, _callee222, this);
      }));

      function condominiumUserCreate(_x357, _x358) {
        return _condominiumUserCreate.apply(this, arguments);
      }

      return condominiumUserCreate;
    }()
  }, {
    key: "condominiumUserDelete",
    value: function () {
      var _condominiumUserDelete = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee223(id, userId) {
        return _regeneratorRuntime.wrap(function _callee223$(_context223) {
          while (1) {
            switch (_context223.prev = _context223.next) {
              case 0:
                return _context223.abrupt("return", this.requestService.delete("condominium/".concat(id, "/users/").concat(userId)).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('condominiumUserDelete', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context223.stop();
            }
          }
        }, _callee223, this);
      }));

      function condominiumUserDelete(_x359, _x360) {
        return _condominiumUserDelete.apply(this, arguments);
      }

      return condominiumUserDelete;
    }()
  }, {
    key: "condominiumUserEdit",
    value: function () {
      var _condominiumUserEdit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee224(id, userId, payload) {
        return _regeneratorRuntime.wrap(function _callee224$(_context224) {
          while (1) {
            switch (_context224.prev = _context224.next) {
              case 0:
                return _context224.abrupt("return", this.requestService.put("condominium/".concat(id, "/users/").concat(userId), payload).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('condominiumUserEdit', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context224.stop();
            }
          }
        }, _callee224, this);
      }));

      function condominiumUserEdit(_x361, _x362, _x363) {
        return _condominiumUserEdit.apply(this, arguments);
      }

      return condominiumUserEdit;
    }()
  }, {
    key: "getApartmentUsers",
    value: function () {
      var _getApartmentUsers = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee225(condoId, apartmentId, dataAttribute) {
        return _regeneratorRuntime.wrap(function _callee225$(_context225) {
          while (1) {
            switch (_context225.prev = _context225.next) {
              case 0:
                return _context225.abrupt("return", this.requestService.get("condominium/".concat(condoId, "/apartments/").concat(apartmentId, "/users")).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result) {
                    return _logicError('getApartmentUsers', result);
                  }

                  return dataAttribute ? _defineProperty({}, dataAttribute, result) : result;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context225.stop();
            }
          }
        }, _callee225, this);
      }));

      function getApartmentUsers(_x364, _x365, _x366) {
        return _getApartmentUsers.apply(this, arguments);
      }

      return getApartmentUsers;
    }()
  }, {
    key: "modifyApartmentRole",
    value: function () {
      var _modifyApartmentRole = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee226(condoId, apartmentId, userId, payload) {
        return _regeneratorRuntime.wrap(function _callee226$(_context226) {
          while (1) {
            switch (_context226.prev = _context226.next) {
              case 0:
                return _context226.abrupt("return", this.requestService.post("condominium/".concat(condoId, "/apartments/").concat(apartmentId, "/user/").concat(userId, "/modifyRole"), payload).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('modifyApartmentRole', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context226.stop();
            }
          }
        }, _callee226, this);
      }));

      function modifyApartmentRole(_x367, _x368, _x369, _x370) {
        return _modifyApartmentRole.apply(this, arguments);
      }

      return modifyApartmentRole;
    }()
  }, {
    key: "getApartmentAllowedRoles",
    value: function () {
      var _getApartmentAllowedRoles = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee227(condoId, apartmentId) {
        return _regeneratorRuntime.wrap(function _callee227$(_context227) {
          while (1) {
            switch (_context227.prev = _context227.next) {
              case 0:
                return _context227.abrupt("return", this.requestService.get("condominium/".concat(condoId, "/apartments/").concat(apartmentId, "/getAllowedRoles")).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result) {
                    return _logicError('getApartmentAllowedRoles', result);
                  }

                  return result;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context227.stop();
            }
          }
        }, _callee227, this);
      }));

      function getApartmentAllowedRoles(_x371, _x372) {
        return _getApartmentAllowedRoles.apply(this, arguments);
      }

      return getApartmentAllowedRoles;
    }()
  }, {
    key: "removeAptUserRole",
    value: function () {
      var _removeAptUserRole = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee228(condoId, apartmentId, userId, payload) {
        return _regeneratorRuntime.wrap(function _callee228$(_context228) {
          while (1) {
            switch (_context228.prev = _context228.next) {
              case 0:
                return _context228.abrupt("return", this.requestService.delete("condominium/".concat(condoId, "/apartments/").concat(apartmentId, "/user/").concat(userId, "/destroy"), payload).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result) {
                    return _logicError('removeAptUserRole', result);
                  }

                  return result;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context228.stop();
            }
          }
        }, _callee228, this);
      }));

      function removeAptUserRole(_x373, _x374, _x375, _x376) {
        return _removeAptUserRole.apply(this, arguments);
      }

      return removeAptUserRole;
    }()
  }, {
    key: "quoteForRoomCardGet",
    value: function () {
      var _quoteForRoomCardGet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee229(quoteId, materialFormId, dataAttribute) {
        return _regeneratorRuntime.wrap(function _callee229$(_context229) {
          while (1) {
            switch (_context229.prev = _context229.next) {
              case 0:
                return _context229.abrupt("return", this.requestService.get("materialquotes/".concat(quoteId, "/").concat(materialFormId)).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result) {
                    return _logicError('quoteForRoomCardGet', result);
                  }

                  return dataAttribute ? _defineProperty({}, dataAttribute, result) : result;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context229.stop();
            }
          }
        }, _callee229, this);
      }));

      function quoteForRoomCardGet(_x377, _x378, _x379) {
        return _quoteForRoomCardGet.apply(this, arguments);
      }

      return quoteForRoomCardGet;
    }()
  }, {
    key: "roomCardSelectionsGet",
    value: function () {
      var _roomCardSelectionsGet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee230(quoteId, dataAttribute) {
        return _regeneratorRuntime.wrap(function _callee230$(_context230) {
          while (1) {
            switch (_context230.prev = _context230.next) {
              case 0:
                return _context230.abrupt("return", this.requestService.get("materialquotes/".concat(quoteId, "/selections")).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result) {
                    return _logicError('roomCardSelectionsGet', result);
                  }

                  return dataAttribute ? _defineProperty({}, dataAttribute, result.data) : result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context230.stop();
            }
          }
        }, _callee230, this);
      }));

      function roomCardSelectionsGet(_x380, _x381) {
        return _roomCardSelectionsGet.apply(this, arguments);
      }

      return roomCardSelectionsGet;
    }()
  }, {
    key: "roomCardUpload",
    value: function () {
      var _roomCardUpload = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee231(quoteId, file) {
        return _regeneratorRuntime.wrap(function _callee231$(_context231) {
          while (1) {
            switch (_context231.prev = _context231.next) {
              case 0:
                return _context231.abrupt("return", this.requestService.put("room-card/".concat(quoteId, "/upload"), file, true).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result) {
                    return _logicError('roomCardUpload', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context231.stop();
            }
          }
        }, _callee231, this);
      }));

      function roomCardUpload(_x382, _x383) {
        return _roomCardUpload.apply(this, arguments);
      }

      return roomCardUpload;
    }()
  }, {
    key: "roomCardDownload",
    value: function () {
      var _roomCardDownload = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee232(quoteId) {
        return _regeneratorRuntime.wrap(function _callee232$(_context232) {
          while (1) {
            switch (_context232.prev = _context232.next) {
              case 0:
                return _context232.abrupt("return", this.requestService.get("room-card/".concat(quoteId, "/download")).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result) {
                    return _logicError('roomCardDownload', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context232.stop();
            }
          }
        }, _callee232, this);
      }));

      function roomCardDownload(_x384) {
        return _roomCardDownload.apply(this, arguments);
      }

      return roomCardDownload;
    }()
  }, {
    key: "roomCardDelete",
    value: function () {
      var _roomCardDelete = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee233(quoteId) {
        return _regeneratorRuntime.wrap(function _callee233$(_context233) {
          while (1) {
            switch (_context233.prev = _context233.next) {
              case 0:
                return _context233.abrupt("return", this.requestService.delete("room-card/".concat(quoteId, "/delete")).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result) {
                    return _logicError('roomCardDelete', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context233.stop();
            }
          }
        }, _callee233, this);
      }));

      function roomCardDelete(_x385) {
        return _roomCardDelete.apply(this, arguments);
      }

      return roomCardDelete;
    }()
  }, {
    key: "roomCardApprove",
    value: function () {
      var _roomCardApprove = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee234(quoteId) {
        return _regeneratorRuntime.wrap(function _callee234$(_context234) {
          while (1) {
            switch (_context234.prev = _context234.next) {
              case 0:
                return _context234.abrupt("return", this.requestService.post("room-card/".concat(quoteId, "/approve")).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result) {
                    return _logicError('roomCardApprove', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context234.stop();
            }
          }
        }, _callee234, this);
      }));

      function roomCardApprove(_x386) {
        return _roomCardApprove.apply(this, arguments);
      }

      return roomCardApprove;
    }()
  }, {
    key: "newUserRequestCreate",
    value: function () {
      var _newUserRequestCreate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee235(payload, dataAttribute) {
        return _regeneratorRuntime.wrap(function _callee235$(_context235) {
          while (1) {
            switch (_context235.prev = _context235.next) {
              case 0:
                return _context235.abrupt("return", this.requestService.post("portal/user", payload).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result) {
                    return _logicError('newUserRequestCreate', result);
                  }

                  return dataAttribute ? _defineProperty({}, dataAttribute, result.data) : result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context235.stop();
            }
          }
        }, _callee235, this);
      }));

      function newUserRequestCreate(_x387, _x388) {
        return _newUserRequestCreate.apply(this, arguments);
      }

      return newUserRequestCreate;
    }()
  }, {
    key: "additionalProductsGet",
    value: function () {
      var _additionalProductsGet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee236(dataAttribute) {
        return _regeneratorRuntime.wrap(function _callee236$(_context236) {
          while (1) {
            switch (_context236.prev = _context236.next) {
              case 0:
                return _context236.abrupt("return", this.requestService.get("additional-products").then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result) {
                    return _logicError('additionalProductsGet', result);
                  }

                  return dataAttribute ? _defineProperty({}, dataAttribute, result.data) : result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context236.stop();
            }
          }
        }, _callee236, this);
      }));

      function additionalProductsGet(_x389) {
        return _additionalProductsGet.apply(this, arguments);
      }

      return additionalProductsGet;
    }()
  }, {
    key: "additionalProductAdd",
    value: function () {
      var _additionalProductAdd = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee237(formData) {
        return _regeneratorRuntime.wrap(function _callee237$(_context237) {
          while (1) {
            switch (_context237.prev = _context237.next) {
              case 0:
                return _context237.abrupt("return", this.requestService.post("additional-products/add", formData).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result) {
                    return _logicError('additionalProductAdd', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context237.stop();
            }
          }
        }, _callee237, this);
      }));

      function additionalProductAdd(_x390) {
        return _additionalProductAdd.apply(this, arguments);
      }

      return additionalProductAdd;
    }()
  }, {
    key: "additionalProductEdit",
    value: function () {
      var _additionalProductEdit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee238(id, payload) {
        return _regeneratorRuntime.wrap(function _callee238$(_context238) {
          while (1) {
            switch (_context238.prev = _context238.next) {
              case 0:
                return _context238.abrupt("return", this.requestService.put("additional-products/".concat(id), payload, true).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('productsEdit', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context238.stop();
            }
          }
        }, _callee238, this);
      }));

      function additionalProductEdit(_x391, _x392) {
        return _additionalProductEdit.apply(this, arguments);
      }

      return additionalProductEdit;
    }()
  }, {
    key: "additionalProductDelete",
    value: function () {
      var _additionalProductDelete = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee239(id) {
        return _regeneratorRuntime.wrap(function _callee239$(_context239) {
          while (1) {
            switch (_context239.prev = _context239.next) {
              case 0:
                return _context239.abrupt("return", this.requestService.delete("additional-products/".concat(id)).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result) {
                    return _logicError('additionalProductDelete', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context239.stop();
            }
          }
        }, _callee239, this);
      }));

      function additionalProductDelete(_x393) {
        return _additionalProductDelete.apply(this, arguments);
      }

      return additionalProductDelete;
    }()
  }, {
    key: "additionalProductsForMaterialFormGet",
    value: function () {
      var _additionalProductsForMaterialFormGet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee240(formId, dataAttribute) {
        return _regeneratorRuntime.wrap(function _callee240$(_context240) {
          while (1) {
            switch (_context240.prev = _context240.next) {
              case 0:
                return _context240.abrupt("return", this.requestService.get("additional-products/form/".concat(formId)).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result) {
                    return _logicError('additionalProductDelete', result);
                  }

                  return dataAttribute ? _defineProperty({}, dataAttribute, result.data) : result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context240.stop();
            }
          }
        }, _callee240, this);
      }));

      function additionalProductsForMaterialFormGet(_x394, _x395) {
        return _additionalProductsForMaterialFormGet.apply(this, arguments);
      }

      return additionalProductsForMaterialFormGet;
    }()
  }, {
    key: "materialQuoteAdditionalRowAdd",
    value: function () {
      var _materialQuoteAdditionalRowAdd = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee241(quoteId, payload) {
        return _regeneratorRuntime.wrap(function _callee241$(_context241) {
          while (1) {
            switch (_context241.prev = _context241.next) {
              case 0:
                return _context241.abrupt("return", this.requestService.post("quote-additional-rows/quote/".concat(quoteId), payload).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result) {
                    return _logicError('materialQuoteAdditionalRowAdd', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context241.stop();
            }
          }
        }, _callee241, this);
      }));

      function materialQuoteAdditionalRowAdd(_x396, _x397) {
        return _materialQuoteAdditionalRowAdd.apply(this, arguments);
      }

      return materialQuoteAdditionalRowAdd;
    }()
  }, {
    key: "materialQuoteAdditionalRowsGet",
    value: function () {
      var _materialQuoteAdditionalRowsGet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee242(quoteId, dataAttribute) {
        return _regeneratorRuntime.wrap(function _callee242$(_context242) {
          while (1) {
            switch (_context242.prev = _context242.next) {
              case 0:
                return _context242.abrupt("return", this.requestService.get("quote-additional-rows/quote/".concat(quoteId)).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result) {
                    return _logicError('materialQuoteAdditionalRowsGet', result);
                  }

                  return dataAttribute ? _defineProperty({}, dataAttribute, result.data) : result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context242.stop();
            }
          }
        }, _callee242, this);
      }));

      function materialQuoteAdditionalRowsGet(_x398, _x399) {
        return _materialQuoteAdditionalRowsGet.apply(this, arguments);
      }

      return materialQuoteAdditionalRowsGet;
    }()
  }, {
    key: "materialQuoteAdditionalRowsDelete",
    value: function () {
      var _materialQuoteAdditionalRowsDelete = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee243(quoteId, rowId, dataAttribute) {
        return _regeneratorRuntime.wrap(function _callee243$(_context243) {
          while (1) {
            switch (_context243.prev = _context243.next) {
              case 0:
                return _context243.abrupt("return", this.requestService.delete("quote-additional-rows/quote/".concat(quoteId, "/row/").concat(rowId)).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result) {
                    return _logicError('materialQuoteAdditionalRowsDelete', result);
                  }

                  return dataAttribute ? _defineProperty({}, dataAttribute, result.data) : result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context243.stop();
            }
          }
        }, _callee243, this);
      }));

      function materialQuoteAdditionalRowsDelete(_x400, _x401, _x402) {
        return _materialQuoteAdditionalRowsDelete.apply(this, arguments);
      }

      return materialQuoteAdditionalRowsDelete;
    }()
  }, {
    key: "materialQuoteAdditionalRowEdit",
    value: function () {
      var _materialQuoteAdditionalRowEdit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee244(quoteId, rowId, payload, dataAttribute) {
        return _regeneratorRuntime.wrap(function _callee244$(_context244) {
          while (1) {
            switch (_context244.prev = _context244.next) {
              case 0:
                return _context244.abrupt("return", this.requestService.put("quote-additional-rows/quote/".concat(quoteId, "/row/").concat(rowId), payload, true).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result) {
                    return _logicError('materialQuoteAdditionalRowEdit', result);
                  }

                  return dataAttribute ? _defineProperty({}, dataAttribute, result.data) : result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context244.stop();
            }
          }
        }, _callee244, this);
      }));

      function materialQuoteAdditionalRowEdit(_x403, _x404, _x405, _x406) {
        return _materialQuoteAdditionalRowEdit.apply(this, arguments);
      }

      return materialQuoteAdditionalRowEdit;
    }()
  }, {
    key: "materialQuoteRowsGet",
    value: function () {
      var _materialQuoteRowsGet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee245(quoteId, dataAttribute) {
        return _regeneratorRuntime.wrap(function _callee245$(_context245) {
          while (1) {
            switch (_context245.prev = _context245.next) {
              case 0:
                return _context245.abrupt("return", this.requestService.get("materialquotes/".concat(quoteId, "/rows")).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result) {
                    return _logicError('materialQuoteRowsGet', result);
                  }

                  return dataAttribute ? _defineProperty({}, dataAttribute, result.data) : result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context245.stop();
            }
          }
        }, _callee245, this);
      }));

      function materialQuoteRowsGet(_x407, _x408) {
        return _materialQuoteRowsGet.apply(this, arguments);
      }

      return materialQuoteRowsGet;
    }()
  }, {
    key: "tagsGet",
    value: function () {
      var _tagsGet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee246() {
        return _regeneratorRuntime.wrap(function _callee246$(_context246) {
          while (1) {
            switch (_context246.prev = _context246.next) {
              case 0:
                return _context246.abrupt("return", this.requestService.get("tags").then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result) {
                    return _logicError('tagsGet', result);
                  }

                  return result;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context246.stop();
            }
          }
        }, _callee246, this);
      }));

      function tagsGet() {
        return _tagsGet.apply(this, arguments);
      }

      return tagsGet;
    }() // gets products belonging to tag

  }, {
    key: "tagProductsGet",
    value: function () {
      var _tagProductsGet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee247(id) {
        return _regeneratorRuntime.wrap(function _callee247$(_context247) {
          while (1) {
            switch (_context247.prev = _context247.next) {
              case 0:
                return _context247.abrupt("return", this.requestService.get("producttags/".concat(id, "/products")).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result) {
                    return _logicError('tagProductsGet', result);
                  }

                  return result;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context247.stop();
            }
          }
        }, _callee247, this);
      }));

      function tagProductsGet(_x409) {
        return _tagProductsGet.apply(this, arguments);
      }

      return tagProductsGet;
    }()
  }, {
    key: "categoryProductTagsGet",
    value: function () {
      var _categoryProductTagsGet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee248(id) {
        return _regeneratorRuntime.wrap(function _callee248$(_context248) {
          while (1) {
            switch (_context248.prev = _context248.next) {
              case 0:
                return _context248.abrupt("return", this.requestService.get("productcategories/".concat(id, "/tags")).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result) {
                    _logicError('categoryProductTagsGet', result);
                  }

                  return result;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context248.stop();
            }
          }
        }, _callee248, this);
      }));

      function categoryProductTagsGet(_x410) {
        return _categoryProductTagsGet.apply(this, arguments);
      }

      return categoryProductTagsGet;
    }()
  }, {
    key: "tagCreate",
    value: function () {
      var _tagCreate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee249(payload) {
        return _regeneratorRuntime.wrap(function _callee249$(_context249) {
          while (1) {
            switch (_context249.prev = _context249.next) {
              case 0:
                return _context249.abrupt("return", this.requestService.post("tags", payload).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    _logicError('tagCreate', result);
                  }

                  return result;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context249.stop();
            }
          }
        }, _callee249, this);
      }));

      function tagCreate(_x411) {
        return _tagCreate.apply(this, arguments);
      }

      return tagCreate;
    }()
  }, {
    key: "tagDelete",
    value: function () {
      var _tagDelete = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee250(id) {
        return _regeneratorRuntime.wrap(function _callee250$(_context250) {
          while (1) {
            switch (_context250.prev = _context250.next) {
              case 0:
                return _context250.abrupt("return", this.requestService.delete("tags/".concat(id)).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result) {
                    return _logicError('tagDelete', result);
                  }

                  return result;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context250.stop();
            }
          }
        }, _callee250, this);
      }));

      function tagDelete(_x412) {
        return _tagDelete.apply(this, arguments);
      }

      return tagDelete;
    }()
  }, {
    key: "tagEdit",
    value: function () {
      var _tagEdit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee251(id, payload) {
        return _regeneratorRuntime.wrap(function _callee251$(_context251) {
          while (1) {
            switch (_context251.prev = _context251.next) {
              case 0:
                return _context251.abrupt("return", this.requestService.put("tags/".concat(id), payload).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    _logicError('tagEdit', result);
                  }

                  return result;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context251.stop();
            }
          }
        }, _callee251, this);
      }));

      function tagEdit(_x413, _x414) {
        return _tagEdit.apply(this, arguments);
      }

      return tagEdit;
    }()
  }, {
    key: "mobilelinkGet",
    value: function () {
      var _mobilelinkGet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee252() {
        return _regeneratorRuntime.wrap(function _callee252$(_context252) {
          while (1) {
            switch (_context252.prev = _context252.next) {
              case 0:
                return _context252.abrupt("return", this.requestService.get("mobilelinks").then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result) {
                    return _logicError('mobilelinkGet', result);
                  }

                  return result;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context252.stop();
            }
          }
        }, _callee252, this);
      }));

      function mobilelinkGet() {
        return _mobilelinkGet.apply(this, arguments);
      }

      return mobilelinkGet;
    }()
  }, {
    key: "mobilelinkCreate",
    value: function () {
      var _mobilelinkCreate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee253(payload) {
        return _regeneratorRuntime.wrap(function _callee253$(_context253) {
          while (1) {
            switch (_context253.prev = _context253.next) {
              case 0:
                return _context253.abrupt("return", this.requestService.post("mobilelinks", payload).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    _logicError('mobilelinkCreate', result);
                  }

                  return result;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context253.stop();
            }
          }
        }, _callee253, this);
      }));

      function mobilelinkCreate(_x415) {
        return _mobilelinkCreate.apply(this, arguments);
      }

      return mobilelinkCreate;
    }()
  }, {
    key: "mobilelinkDelete",
    value: function () {
      var _mobilelinkDelete = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee254(id) {
        return _regeneratorRuntime.wrap(function _callee254$(_context254) {
          while (1) {
            switch (_context254.prev = _context254.next) {
              case 0:
                return _context254.abrupt("return", this.requestService.delete("mobilelinks/".concat(id)).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result) {
                    return _logicError('mobilelinkDelete', result);
                  }

                  return result;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context254.stop();
            }
          }
        }, _callee254, this);
      }));

      function mobilelinkDelete(_x416) {
        return _mobilelinkDelete.apply(this, arguments);
      }

      return mobilelinkDelete;
    }()
  }, {
    key: "mobilelinkEdit",
    value: function () {
      var _mobilelinkEdit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee255(id, payload) {
        return _regeneratorRuntime.wrap(function _callee255$(_context255) {
          while (1) {
            switch (_context255.prev = _context255.next) {
              case 0:
                return _context255.abrupt("return", this.requestService.put("mobilelinks/".concat(id), payload).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    _logicError('mobilelinkEdit', result);
                  }

                  return result;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context255.stop();
            }
          }
        }, _callee255, this);
      }));

      function mobilelinkEdit(_x417, _x418) {
        return _mobilelinkEdit.apply(this, arguments);
      }

      return mobilelinkEdit;
    }()
  }, {
    key: "csvImport",
    value: function () {
      var _csvImport = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee256(type, payload) {
        return _regeneratorRuntime.wrap(function _callee256$(_context256) {
          while (1) {
            switch (_context256.prev = _context256.next) {
              case 0:
                return _context256.abrupt("return", this.requestService.csvImport(type, payload).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    _logicError('csvImport', result);
                  }

                  return result;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context256.stop();
            }
          }
        }, _callee256, this);
      }));

      function csvImport(_x419, _x420) {
        return _csvImport.apply(this, arguments);
      }

      return csvImport;
    }()
  }, {
    key: "progressNumbersGet",
    value: function () {
      var _progressNumbersGet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee257(projectId) {
        return _regeneratorRuntime.wrap(function _callee257$(_context257) {
          while (1) {
            switch (_context257.prev = _context257.next) {
              case 0:
                return _context257.abrupt("return", this.requestService.get("projects/".concat(projectId, "/progressnumber-submissions")).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result) {
                    _logicError('progressnumbersGet', result);
                  }

                  return result;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context257.stop();
            }
          }
        }, _callee257, this);
      }));

      function progressNumbersGet(_x421) {
        return _progressNumbersGet.apply(this, arguments);
      }

      return progressNumbersGet;
    }()
  }, {
    key: "progressNumbersDelete",
    value: function () {
      var _progressNumbersDelete = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee258(projectId, id) {
        return _regeneratorRuntime.wrap(function _callee258$(_context258) {
          while (1) {
            switch (_context258.prev = _context258.next) {
              case 0:
                return _context258.abrupt("return", this.requestService.delete("projects/".concat(projectId, "/progressnumber-submissions/").concat(id)).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result) {
                    return _logicError('progressNumbersDelete', result);
                  }

                  return result;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context258.stop();
            }
          }
        }, _callee258, this);
      }));

      function progressNumbersDelete(_x422, _x423) {
        return _progressNumbersDelete.apply(this, arguments);
      }

      return progressNumbersDelete;
    }()
  }, {
    key: "progressNumbersAdd",
    value: function () {
      var _progressNumbersAdd = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee259(projectId, payload) {
        return _regeneratorRuntime.wrap(function _callee259$(_context259) {
          while (1) {
            switch (_context259.prev = _context259.next) {
              case 0:
                return _context259.abrupt("return", this.requestService.post("projects/".concat(projectId, "/progressnumber-submissions"), payload).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result) {
                    return _logicError('progressNumbersAdd', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context259.stop();
            }
          }
        }, _callee259, this);
      }));

      function progressNumbersAdd(_x424, _x425) {
        return _progressNumbersAdd.apply(this, arguments);
      }

      return progressNumbersAdd;
    }()
  }, {
    key: "summaryViewsGet",
    value: function () {
      var _summaryViewsGet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee260() {
        return _regeneratorRuntime.wrap(function _callee260$(_context260) {
          while (1) {
            switch (_context260.prev = _context260.next) {
              case 0:
                return _context260.abrupt("return", this.requestService.get("summaryviews").then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result) {
                    return _logicError('summaryviewsGet', result);
                  }

                  return result;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context260.stop();
            }
          }
        }, _callee260, this);
      }));

      function summaryViewsGet() {
        return _summaryViewsGet.apply(this, arguments);
      }

      return summaryViewsGet;
    }()
  }, {
    key: "summaryViewsGetDocuments",
    value: function () {
      var _summaryViewsGetDocuments = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee261(id, fields, converterFunc, dataAttribute) {
        return _regeneratorRuntime.wrap(function _callee261$(_context261) {
          while (1) {
            switch (_context261.prev = _context261.next) {
              case 0:
                return _context261.abrupt("return", this.requestService.get("summaryviews/".concat(id, "/documents")).then(function (result) {
                  if (result.error) {
                    return {
                      error: result.error
                    };
                  }

                  var results = result.data.map(function (item, index) {
                    return converterFunc(item, id, fields, index);
                  });
                  return dataAttribute ? _defineProperty({}, dataAttribute, results) : results;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context261.stop();
            }
          }
        }, _callee261, this);
      }));

      function summaryViewsGetDocuments(_x426, _x427, _x428, _x429) {
        return _summaryViewsGetDocuments.apply(this, arguments);
      }

      return summaryViewsGetDocuments;
    }()
  }, {
    key: "summaryViewCreate",
    value: function () {
      var _summaryViewCreate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee262(payload) {
        return _regeneratorRuntime.wrap(function _callee262$(_context262) {
          while (1) {
            switch (_context262.prev = _context262.next) {
              case 0:
                return _context262.abrupt("return", this.requestService.post("summaryviews", payload).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    _logicError('summaryViewCreate', result);
                  }

                  return result;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context262.stop();
            }
          }
        }, _callee262, this);
      }));

      function summaryViewCreate(_x430) {
        return _summaryViewCreate.apply(this, arguments);
      }

      return summaryViewCreate;
    }()
  }, {
    key: "summaryViewDelete",
    value: function () {
      var _summaryViewDelete = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee263(id) {
        return _regeneratorRuntime.wrap(function _callee263$(_context263) {
          while (1) {
            switch (_context263.prev = _context263.next) {
              case 0:
                return _context263.abrupt("return", this.requestService.delete("summaryviews/".concat(id)).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result) {
                    return _logicError('summaryviewDelete', result);
                  }

                  return result;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context263.stop();
            }
          }
        }, _callee263, this);
      }));

      function summaryViewDelete(_x431) {
        return _summaryViewDelete.apply(this, arguments);
      }

      return summaryViewDelete;
    }()
  }, {
    key: "oneSummaryViewGet",
    value: function () {
      var _oneSummaryViewGet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee264(id) {
        return _regeneratorRuntime.wrap(function _callee264$(_context264) {
          while (1) {
            switch (_context264.prev = _context264.next) {
              case 0:
                return _context264.abrupt("return", this.requestService.get("summaryviews/".concat(id)).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result) {
                    _logicError('oneSummaryViewGet', result);
                  }

                  return result;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context264.stop();
            }
          }
        }, _callee264, this);
      }));

      function oneSummaryViewGet(_x432) {
        return _oneSummaryViewGet.apply(this, arguments);
      }

      return oneSummaryViewGet;
    }()
  }, {
    key: "companyAttachmentDelete",
    value: function () {
      var _companyAttachmentDelete = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee265(companyId, id) {
        return _regeneratorRuntime.wrap(function _callee265$(_context265) {
          while (1) {
            switch (_context265.prev = _context265.next) {
              case 0:
                return _context265.abrupt("return", this.requestService.get("summaryviews/".concat(id, "/companies/remove/").concat(companyId)).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result) {
                    return _logicError('companyAttachmentDelete', result);
                  }

                  return result;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context265.stop();
            }
          }
        }, _callee265, this);
      }));

      function companyAttachmentDelete(_x433, _x434) {
        return _companyAttachmentDelete.apply(this, arguments);
      }

      return companyAttachmentDelete;
    }()
  }, {
    key: "companyAttachmentAdd",
    value: function () {
      var _companyAttachmentAdd = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee266(companyId, id) {
        return _regeneratorRuntime.wrap(function _callee266$(_context266) {
          while (1) {
            switch (_context266.prev = _context266.next) {
              case 0:
                return _context266.abrupt("return", this.requestService.get("summaryviews/".concat(id, "/companies/add/").concat(companyId)).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result) {
                    return _logicError('companyAttachmentAdd', result);
                  }

                  return result;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context266.stop();
            }
          }
        }, _callee266, this);
      }));

      function companyAttachmentAdd(_x435, _x436) {
        return _companyAttachmentAdd.apply(this, arguments);
      }

      return companyAttachmentAdd;
    }()
  }, {
    key: "userDelete",
    value: function () {
      var _userDelete = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee267(id) {
        return _regeneratorRuntime.wrap(function _callee267$(_context267) {
          while (1) {
            switch (_context267.prev = _context267.next) {
              case 0:
                return _context267.abrupt("return", this.requestService.delete("users/".concat(id)).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    return _logicError('UserDelete', result);
                  }

                  return result.data;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context267.stop();
            }
          }
        }, _callee267, this);
      }));

      function userDelete(_x437) {
        return _userDelete.apply(this, arguments);
      }

      return userDelete;
    }()
  }, {
    key: "summaryViewUpdateDocumentStatus",
    value: function () {
      var _summaryViewUpdateDocumentStatus = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee268(payload, summaryviewId, documentId) {
        return _regeneratorRuntime.wrap(function _callee268$(_context268) {
          while (1) {
            switch (_context268.prev = _context268.next) {
              case 0:
                return _context268.abrupt("return", this.requestService.post("summaryviews/".concat(summaryviewId, "/documents/").concat(documentId, "/status"), payload).then(function (result) {
                  if (_getResultError(result)) {
                    return _getResultError(result);
                  }

                  if (!result.data) {
                    _logicError('updateDocumentStatus', result);
                  }

                  return result;
                }).catch(_catcherInTheCode));

              case 1:
              case "end":
                return _context268.stop();
            }
          }
        }, _callee268, this);
      }));

      function summaryViewUpdateDocumentStatus(_x438, _x439, _x440) {
        return _summaryViewUpdateDocumentStatus.apply(this, arguments);
      }

      return summaryViewUpdateDocumentStatus;
    }()
  }]);

  return AvainiaCore;
}();

export { AvainiaCore as default };